import { inject as be, getCurrentInstance as f1, computed as w, unref as r, ref as S, shallowRef as p1, watch as D, getCurrentScope as St, onScopeDispose as Ct, shallowReadonly as se, warn as m1, provide as te, onMounted as h1, onBeforeUnmount as g1, defineComponent as _, reactive as Ht, toRef as v1, openBlock as v, createElementBlock as P, createElementVNode as T, renderSlot as y, createBlock as b, resolveDynamicComponent as It, withCtx as g, normalizeClass as x, withKeys as ge, mergeProps as re, createCommentVNode as J, createStaticVNode as b1, createVNode as $, useCssVars as oe, toDisplayString as G, createTextVNode as O, Transition as y1, watchEffect as _1, Fragment as ke, normalizeProps as Nt, guardReactiveProps as Vt, withModifiers as ct, renderList as Ee, camelize as w1, mergeModels as rt, useModel as x1, toRaw as ut } from "vue";
import { useLink as M1 } from "vue-router";
if (typeof window < "u") {
  let e = function() {
    var t = document.body, o = document.getElementById("__svg__icons__dom__");
    o || (o = document.createElementNS("http://www.w3.org/2000/svg", "svg"), o.style.position = "absolute", o.style.width = "0", o.style.height = "0", o.id = "__svg__icons__dom__", o.setAttribute("xmlns", "http://www.w3.org/2000/svg"), o.setAttribute("xmlns:link", "http://www.w3.org/1999/xlink")), o.innerHTML = '<symbol viewBox="0 0 16 16"  id="bg-icon-accessible"><path d="m14.247 7.994-.403 4.915c-.103 1.272-1.997 1.097-1.894-.153l.313-3.828L10.977 9a4.865 4.865 0 0 1-.828 5.469L8.922 13.24c1.81-1.991.41-5.225-2.313-5.225-.809 0-1.546.309-2.1.812L3.281 7.6a4.847 4.847 0 0 1 2.544-1.256l2.353-2.678-1.331-.775-1.613 1.437c-.937.838-2.206-.578-1.265-1.419l2.125-1.896A.947.947 0 0 1 7.204.9s4.352 2.528 4.359 2.534c.506.316.646 1.125.19 1.644L9.928 7.156l3.316-.184a.948.948 0 0 1 1.003 1.022ZM12.219 3.18A1.591 1.591 0 1 0 12.218 0a1.591 1.591 0 0 0 0 3.182ZM6.613 14.266c-2.52 0-3.982-2.832-2.585-4.879l-1.24-1.24a4.807 4.807 0 0 0-1.038 2.99c0 4.085 4.71 6.294 7.856 3.829l-1.24-1.241c-.5.34-1.103.54-1.753.54Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-alert"><g clip-path="url(#bg-icon-alert_a)"><path d="M8 16A8 8 0 1 0 8-.001 8 8 0 0 0 8 16ZM8 4c.416 0 .75.334.75.75v3.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-3.5c0-.416.334-.75.75-.75Zm-1 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z" /></g><defs><clipPath id="bg-icon-alert_a"><path d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 8 9"  id="bg-icon-back-arrow"><path d="M6.625 6.546c0 .25.195.454.437.454a.446.446 0 0 0 .438-.454V5.182c0-.752-.588-1.363-1.313-1.363H1.994l1.004-1.043a.468.468 0 0 0 0-.643.427.427 0 0 0-.62 0L.628 3.951a.468.468 0 0 0 0 .643l1.75 1.818c.171.178.449.178.62 0a.468.468 0 0 0 0-.643L1.994 4.728h4.193c.242 0 .438.203.438.454v1.364Z" /></symbol><symbol viewBox="0 0 14 16"  id="bg-icon-bell"><path d="M7 16a2 2 0 0 0 2-2H5A2 2 0 0 0 7 16Zm6.731-4.678c-.604-.65-1.733-1.625-1.733-4.822 0-2.428-1.703-4.372-3.999-4.849V1a1 1 0 1 0-1.998 0v.651c-2.296.477-3.998 2.42-3.998 4.849 0 3.197-1.13 4.173-1.734 4.822A.976.976 0 0 0 0 12a1 1 0 0 0 1.003 1h11.994A1 1 0 0 0 14 12a.975.975 0 0 0-.269-.678Z" /></symbol><symbol viewBox="0 0 16 15"  id="bg-icon-bucket"><g clip-path="url(#bg-icon-bucket_a)"><path d="M1.15.261a.887.887 0 0 1 1.256 0l2.26 2.258 1.476-1.475a2 2 0 0 1 2.827 0l4.206 4.209a2 2 0 0 1 0 2.828l-5.289 5.291a2.667 2.667 0 0 1-3.772 0L.85 10.108a2.667 2.667 0 0 1 0-3.772l2.558-2.558L1.15 1.517a.89.89 0 0 1 0-1.259v.003Zm4.889 6.147L4.667 5.036 2.108 7.594A.898.898 0 0 0 1.875 8h8.867l1.175-1.175a.223.223 0 0 0 0-.314L7.714 2.303a.223.223 0 0 0-.314 0L5.925 3.778 7.297 5.15A.89.89 0 0 1 6.04 6.408Zm8.183 7.814a1.78 1.78 0 0 1-1.778-1.778c0-.7.906-2.21 1.423-3.019a.418.418 0 0 1 .708 0c.52.808 1.425 2.32 1.425 3.02a1.78 1.78 0 0 1-1.778 1.777Z" /></g><defs><clipPath id="bg-icon-bucket_a"><path fill="#fff" d="M0 0h16v14.222H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-caret-down"><path d="M2.807 5h10.386a.806.806 0 0 1 .569 1.376l-5.19 5.195a.809.809 0 0 1-1.143 0l-5.19-5.195A.806.806 0 0 1 2.806 5Z" /><path d="M2.807 5h10.386a.806.806 0 0 1 .569 1.376l-5.19 5.195a.809.809 0 0 1-1.143 0l-5.19-5.195A.806.806 0 0 1 2.806 5Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-caret-left"><path d="M12 2.807v10.386a.806.806 0 0 1-1.376.569l-5.195-5.19a.809.809 0 0 1 0-1.143l5.195-5.19A.806.806 0 0 1 12 2.806Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-caret-right"><path d="M5 13.193V2.807a.806.806 0 0 1 1.376-.569l5.195 5.19a.809.809 0 0 1 0 1.143l-5.195 5.19A.806.806 0 0 1 5 13.194Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-caret-up"><path d="M13.193 11.807H2.807a.806.806 0 0 1-.569-1.376l5.19-5.195a.809.809 0 0 1 1.143 0l5.19 5.195a.806.806 0 0 1-.568 1.376Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-check-box"><path d="M14.286 16H1.714A1.714 1.714 0 0 1 0 14.286V1.714C0 .767.767 0 1.714 0h12.572C15.233 0 16 .767 16 1.714v12.572c0 .947-.768 1.714-1.714 1.714Zm-7.31-3.502 6.57-6.572a.571.571 0 0 0 0-.808l-.807-.808a.571.571 0 0 0-.808 0L6.57 9.67 4.07 7.166a.571.571 0 0 0-.808 0l-.808.808a.571.571 0 0 0 0 .809l3.714 3.714a.571.571 0 0 0 .809 0Z" /></symbol><symbol viewBox="0 0 8 9"  id="bg-icon-check"><path d="M7.833 1.676a.622.622 0 0 1 0 .849l-4.571 4.8a.553.553 0 0 1-.81 0l-2.285-2.4a.622.622 0 0 1 0-.85.553.553 0 0 1 .81 0L2.857 6.05l4.168-4.373a.553.553 0 0 1 .808 0h-.001Z" /></symbol><symbol viewBox="0 0 10 11"  id="bg-icon-clock"><g clip-path="url(#bg-icon-clock_a)"><path d="M5 .5a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm-.469 2.344V5.5a.47.47 0 0 0 .21.39l1.874 1.25a.468.468 0 0 0 .65-.13.467.467 0 0 0-.13-.65L5.469 5.25V2.844a.468.468 0 1 0-.938 0Z" /></g><defs><clipPath id="bg-icon-clock_a"><path fill="#fff" transform="translate(0 .5)" d="M0 0h10v10H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 9 9"  id="bg-icon-close"><path d="M8.477 1.866A.8.8 0 0 0 7.345.734L4.714 3.368 2.08.737A.8.8 0 0 0 .948 1.869L3.582 4.5.95 7.134a.8.8 0 0 0 1.132 1.132l2.63-2.634 2.635 2.631A.8.8 0 0 0 8.48 7.131L5.846 4.5l2.631-2.634Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-code"><path d="M1.6 4.1c0-.882.717-1.6 1.6-1.6h9.6c.882 0 1.6.717 1.6 1.6v6.4h-1.6V4.1H3.2v6.4H1.6V4.1ZM0 11.78a.48.48 0 0 1 .48-.48h15.04a.48.48 0 0 1 .48.48c0 1.06-.86 1.92-1.92 1.92H1.92A1.92 1.92 0 0 1 0 11.78Zm7.025-4.855L6.25 7.7l.775.775a.6.6 0 0 1-.848.848l-1.2-1.2a.598.598 0 0 1 0-.848l1.2-1.2a.6.6 0 0 1 .848.848v.002Zm2.8-.85 1.2 1.2a.598.598 0 0 1 0 .848l-1.2 1.2a.6.6 0 0 1-.848-.848l.775-.775-.775-.775a.6.6 0 0 1 .848-.848v-.002Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-company"><path d="M.92 6.3h14.16a.92.92 0 0 0 .765-1.43l-1.89-2.835a1.194 1.194 0 0 0-.998-.535H3.043c-.4 0-.774.2-.997.535L.155 4.867A.921.921 0 0 0 .92 6.3Zm.68.8v6a1.2 1.2 0 0 0 1.2 1.2h5.6a1.2 1.2 0 0 0 1.2-1.2v-6H8v4H3.2v-4H1.6Zm11.2 0v6.4a.8.8 0 1 0 1.6 0V7.1h-1.6Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-compass"><g clip-path="url(#bg-icon-compass_a)"><path d="M10.998 3c0 .446-.097.871-.275 1.255l1.65 2.85A5.977 5.977 0 0 1 9.608 8.78l-1.61-2.781L5.874 9.67a7.033 7.033 0 0 0 2.128.328 6.983 6.983 0 0 0 5.464-2.624c.347-.432.975-.5 1.406-.157.431.344.5.975.156 1.406a9 9 0 0 1-7.03 3.375c-1.106 0-2.168-.2-3.146-.566l-1.768 3.056c-.147.253-.366.46-.628.59l-1.731.866A.501.501 0 0 1 0 15.497v-1.73c0-.263.069-.523.203-.754l1.875-3.24c-.4-.35-.772-.734-1.103-1.15a1 1 0 1 1 1.562-1.25c.178.222.369.432.569.629l2.168-3.747A3.003 3.003 0 0 1 7.998 0a3 3 0 0 1 3 3Zm.656 9.307c1.018-.4 1.953-.962 2.778-1.653l1.365 2.36c.131.227.203.487.203.752v1.731a.502.502 0 0 1-.725.447l-1.73-.866a1.506 1.506 0 0 1-.629-.59l-1.262-2.181ZM7.998 3.999a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" /></g><defs><clipPath id="bg-icon-compass_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-computer"><path d="M1.778 1A1.78 1.78 0 0 0 0 2.778v8c0 .98.797 1.778 1.778 1.778h4.889l-.298.888H4.444a.888.888 0 1 0 0 1.778h7.112a.888.888 0 1 0 0-1.778H9.63l-.298-.888h4.89A1.78 1.78 0 0 0 16 10.778v-8A1.78 1.78 0 0 0 14.222 1H1.778Zm12.444 1.778V9H1.778V2.778h12.444Z" /></symbol><symbol viewBox="0 0 22 24"  id="bg-icon-copy"><path d="M18.994 15.75H9.975a.753.753 0 0 1-.751-.75V3c0-.413.338-.75.751-.75h6.581l3.19 3.183V15c0 .412-.339.75-.752.75ZM9.975 18h9.019A3.006 3.006 0 0 0 22 15V5.433c0-.595-.24-1.167-.662-1.59L18.153.662A2.257 2.257 0 0 0 16.561 0H9.975A3.006 3.006 0 0 0 6.97 3v12c0 1.655 1.348 3 3.006 3ZM3.963 6A3.006 3.006 0 0 0 .957 9v12c0 1.655 1.348 3 3.006 3h9.018a3.006 3.006 0 0 0 3.007-3v-1.5h-2.255V21c0 .413-.338.75-.752.75H3.963A.753.753 0 0 1 3.21 21V9c0-.412.338-.75.752-.75h1.503V6H3.963Z" /></symbol><symbol viewBox="0 0 16 17"  id="bg-icon-delete"><path d="M2 14.5A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5V4H2v10.5Zm8.5-8a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7Zm-3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7Zm-3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7Zm10-5.5h-3.75l-.294-.584A.75.75 0 0 0 9.784 0H6.212a.741.741 0 0 0-.668.416L5.25 1H1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-dev"><path d="m6.973 14.786-1.525-.443a.3.3 0 0 1-.205-.372L8.655 2.217a.3.3 0 0 1 .372-.205l1.525.442a.3.3 0 0 1 .205.373L7.345 14.58a.3.3 0 0 1-.372.205Zm-2.85-2.805 1.087-1.16a.3.3 0 0 0-.02-.43L2.925 8.399 5.19 6.406a.298.298 0 0 0 .02-.43l-1.087-1.16a.3.3 0 0 0-.425-.012L.096 8.179a.298.298 0 0 0 0 .437l3.602 3.377c.122.115.312.11.425-.012Zm8.18.015 3.601-3.377a.298.298 0 0 0 0-.438l-3.602-3.38a.303.303 0 0 0-.425.013l-1.087 1.16a.3.3 0 0 0 .02.43l2.265 1.995-2.265 1.992a.298.298 0 0 0-.02.43l1.087 1.16a.3.3 0 0 0 .425.015Z" /></symbol><symbol viewBox="0 0 14 16"  id="bg-icon-doc"><g clip-path="url(#bg-icon-doc_a)"><path d="M0 2C0 .897.897 0 2 0h10c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2V2Zm5.719 6.713A3.006 3.006 0 0 1 4.04 6.5h1.221c.05.95.241 1.681.457 2.213ZM7.009 9H6.99a3.268 3.268 0 0 1-.284-.516C6.52 8.06 6.32 7.412 6.262 6.5h1.472c-.056.912-.253 1.56-.443 1.984-.107.238-.21.407-.285.516h.003Zm1.272-.287c.213-.535.403-1.263.457-2.213h1.221a3.006 3.006 0 0 1-1.678 2.213ZM8.738 5.5c-.05-.95-.241-1.681-.457-2.212A3.006 3.006 0 0 1 9.96 5.5H8.738ZM6.99 3h.019c.074.11.178.278.284.516.187.425.387 1.072.444 1.984H6.265c.056-.912.253-1.56.443-1.984.107-.238.21-.407.285-.516H6.99Zm-1.272.288c-.213.534-.403 1.262-.457 2.212H4.042c.165-.981.806-1.8 1.678-2.212ZM11 6a4 4 0 1 0-8 0 4 4 0 0 0 8 0Zm-7.5 6c-.275 0-.5.225-.5.5s.225.5.5.5h7c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-7Z" /></g><defs><clipPath id="bg-icon-doc_a"><path fill="#fff" d="M0 0h14v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 12 16"  id="bg-icon-dollar-doc"><g clip-path="url(#bg-icon-dollar-doc_a)"><path d="M2 0C.897 0 0 .897 0 2v12c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V5H8c-.553 0-1-.447-1-1V0H2Zm6 0v4h4L8 0ZM2 2.5c0-.275.225-.5.5-.5h2c.275 0 .5.225.5.5s-.225.5-.5.5h-2a.501.501 0 0 1-.5-.5Zm0 2c0-.275.225-.5.5-.5h2c.275 0 .5.225.5.5s-.225.5-.5.5h-2a.501.501 0 0 1-.5-.5Zm4 2.25c.275 0 .5.225.5.5v.54c.266.038.522.098.753.16a.5.5 0 1 1-.26.966c-.346-.094-.687-.163-1.002-.166-.263-.003-.544.056-.738.172-.178.106-.253.228-.253.4 0 .116.04.203.228.316.216.128.519.221.913.34l.015.003c.353.107.79.238 1.135.457.378.237.7.615.709 1.193.01.603-.3 1.04-.716 1.3-.24.15-.512.238-.784.285v.534c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5v-.556a6.697 6.697 0 0 1-.966-.278l-.193-.066a.499.499 0 1 1 .315-.947c.078.025.15.05.222.075.425.144.769.263 1.135.272.284.01.559-.053.74-.166.16-.1.247-.228.244-.437-.003-.144-.056-.244-.24-.363-.213-.134-.516-.23-.907-.35l-.05-.015c-.344-.103-.76-.228-1.087-.428-.375-.225-.707-.591-.71-1.166-.003-.606.338-1.025.744-1.266.234-.137.494-.225.753-.271V7.25c0-.275.225-.5.5-.5Z" /></g><defs><clipPath id="bg-icon-dollar-doc_a"><path fill="#fff" d="M0 0h12v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-dollar"><path d="m10.536 7.294-3.375-.988a.922.922 0 0 1 .26-1.806h2.072c.38 0 .756.116 1.068.328.191.128.447.097.61-.062l1.087-1.063a.507.507 0 0 0-.056-.765A4.419 4.419 0 0 0 9.499 2V.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5V2H7.42C5.43 2 3.83 3.71 4.014 5.737c.132 1.441 1.232 2.613 2.62 3.02l3.202.937a.922.922 0 0 1-.26 1.806h-2.07c-.382 0-.757-.116-1.07-.328a.487.487 0 0 0-.609.062l-1.088 1.063a.507.507 0 0 0 .057.765c.765.6 1.722.935 2.703.938v1.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1.506c1.456-.028 2.822-.894 3.303-2.272a3.432 3.432 0 0 0-2.266-4.428Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-download"><path d="M16 8c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8 8 3.58 8 8Zm-4.632-.932L9.032 9.503v-5.89a.772.772 0 0 0-.774-.774h-.516a.772.772 0 0 0-.774.774v5.89L4.632 7.068a.775.775 0 0 0-1.106-.013l-.352.355a.771.771 0 0 0 0 1.093l4.278 4.28a.771.771 0 0 0 1.093 0l4.28-4.28a.771.771 0 0 0 0-1.093l-.35-.355a.775.775 0 0 0-1.107.013Z" /></symbol><symbol viewBox="0 0 24 24"  id="bg-icon-edit"><path d="M22.106 1.017a2.623 2.623 0 0 0-3.712 0l-1.411 1.406 4.589 4.59 1.41-1.411a2.623 2.623 0 0 0 0-3.713l-.876-.872ZM8.081 11.33a2.59 2.59 0 0 0-.633 1.026L6.061 16.52a1.13 1.13 0 0 0 .272 1.153c.3.305.745.408 1.153.272l4.162-1.388a2.655 2.655 0 0 0 1.027-.633l7.842-7.846-4.594-4.594-7.842 7.847ZM4.5 3A4.501 4.501 0 0 0 0 7.5v12C0 21.984 2.016 24 4.5 24h12c2.484 0 4.5-2.016 4.5-4.5V15c0-.83-.67-1.5-1.5-1.5S18 14.17 18 15v4.5c0 .83-.67 1.5-1.5 1.5h-12c-.83 0-1.5-.67-1.5-1.5v-12C3 6.67 3.67 6 4.5 6H9c.83 0 1.5-.67 1.5-1.5S9.83 3 9 3H4.5Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-email"><path d="M1.5 2a1.5 1.5 0 0 0-.9 2.7l6.8 5.1c.356.266.844.266 1.2 0l6.8-5.1a1.5 1.5 0 0 0-.9-2.7h-13ZM0 5.5V12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V5.5l-6.8 5.1a1.997 1.997 0 0 1-2.4 0L0 5.5Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-euro-circle"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM4.932 7.243c0-.053 0-.104.002-.157H4.62A.624.624 0 0 1 4 6.457c0-.348.278-.628.621-.628h.55C5.745 4.18 7.3 3 9.125 3h.466c.343 0 .62.28.62.629a.624.624 0 0 1-.62.628h-.466c-1.124 0-2.1.637-2.6 1.572H8.97c.344 0 .622.28.622.628a.624.624 0 0 1-.622.629H6.178a4.144 4.144 0 0 0-.004.157v.314c0 .053.002.106.004.157h2.791c.344 0 .622.281.622.629a.624.624 0 0 1-.622.628H6.525a2.947 2.947 0 0 0 2.6 1.572h.466c.343 0 .62.28.62.628a.624.624 0 0 1-.62.629h-.466c-1.825 0-3.38-1.18-3.954-2.829h-.55A.624.624 0 0 1 4 8.343c0-.348.278-.629.621-.629h.313c-.002-.053-.002-.104-.002-.157v-.314Z" fill="inherit" /></symbol><symbol viewBox="0 0 18 17"  id="bg-icon-eye"><g clip-path="url(#bg-icon-eye_a)"><path d="M9 3c-2.037 0-3.712.925-4.997 2.116C2.8 6.234 1.97 7.563 1.543 8.5 1.97 9.438 2.8 10.766 4 11.884 5.288 13.075 6.963 14 9 14c2.038 0 3.713-.925 4.997-2.116 1.203-1.118 2.034-2.447 2.46-3.384C16.03 7.562 15.2 6.234 14 5.116 12.713 3.925 11.038 3 9 3ZM2.981 4.019C4.453 2.65 6.475 1.5 9.001 1.5c2.524 0 4.546 1.15 6.018 2.519 1.462 1.36 2.44 2.981 2.906 4.097a.994.994 0 0 1 0 .768c-.465 1.116-1.444 2.741-2.906 4.097C13.547 14.35 11.525 15.5 9 15.5s-4.547-1.15-6.019-2.519C1.52 11.625.541 10 .078 8.884a.994.994 0 0 1 0-.768C.541 7 1.52 5.375 2.981 4.019ZM9.001 11a2.5 2.5 0 1 0 0-5h-.063A2.002 2.002 0 0 1 6.5 8.438V8.5A2.5 2.5 0 0 0 9 11Zm0-6.5a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z" /></g><defs><clipPath id="bg-icon-eye_a"><path fill="#fff" transform="translate(0 .5)" d="M0 0h18v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 15"  id="bg-icon-filter"><path d="M7.022 14.98a.969.969 0 0 1-.697-.269.886.886 0 0 1-.281-.667V8.427L.2 1.287C-.03 1.022-.061.741.102.445A.808.808 0 0 1 .86 0h14.28c.342 0 .595.148.758.445.163.296.13.577-.098.842l-5.844 7.14v5.617a.886.886 0 0 1-.281.667.969.969 0 0 1-.697.27H7.022Z" /></symbol><symbol viewBox="0 0 51 40"  id="bg-icon-gears"><g clip-path="url(#bg-icon-gears_a)"><path d="M24.602 10.57c.555-.492.774-1.265.485-1.953-.18-.414-.375-.82-.594-1.21l-.242-.423c-.235-.39-.492-.773-.766-1.14-.445-.594-1.226-.79-1.93-.555l-2.203.727a9.9 9.9 0 0 0-2.828-1.633l-.476-2.266c-.149-.726-.711-1.304-1.446-1.39a11.61 11.61 0 0 0-1.57-.102h-.055c-.531 0-1.054.031-1.57.094-.734.086-1.297.672-1.445 1.39l-.477 2.274a9.978 9.978 0 0 0-2.828 1.633l-2.211-.72c-.703-.234-1.484-.038-1.93.556-.273.367-.53.75-.773 1.14l-.234.414c-.22.39-.415.797-.594 1.219-.29.68-.07 1.453.484 1.953l1.735 1.547a10.061 10.061 0 0 0 0 3.258L1.399 16.93c-.555.492-.773 1.265-.484 1.953.18.414.375.82.594 1.219l.234.406c.234.398.492.773.773 1.14.446.594 1.227.79 1.93.555l2.203-.726a9.9 9.9 0 0 0 2.828 1.632l.477 2.274c.148.726.71 1.305 1.445 1.39a13.43 13.43 0 0 0 3.188 0c.734-.085 1.296-.671 1.445-1.39l.477-2.274a9.98 9.98 0 0 0 2.828-1.632l2.203.726c.703.235 1.484.04 1.93-.555.273-.367.53-.742.765-1.14l.242-.422c.219-.39.414-.797.594-1.211.29-.68.07-1.453-.484-1.953l-1.735-1.547c.086-.531.133-1.078.133-1.633 0-.555-.047-1.101-.133-1.633l1.735-1.546.015.007ZM9.251 13.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Zm30.68 25.352c.492.554 1.265.773 1.953.484.414-.18.82-.375 1.21-.594l.422-.242c.391-.234.774-.492 1.141-.766.594-.445.789-1.226.555-1.93l-.727-2.202a9.9 9.9 0 0 0 1.633-2.829l2.273-.476c.727-.149 1.305-.711 1.391-1.445a13.433 13.433 0 0 0 0-3.188c-.086-.734-.672-1.297-1.39-1.445l-2.274-.485a9.978 9.978 0 0 0-1.633-2.828l.727-2.203c.234-.703.039-1.484-.555-1.93-.367-.273-.75-.53-1.14-.773l-.415-.234c-.39-.22-.797-.414-1.218-.594-.68-.29-1.454-.07-1.954.484l-1.547 1.735a10.237 10.237 0 0 0-1.632-.133c-.555 0-1.102.047-1.633.133l-1.547-1.735c-.492-.554-1.266-.773-1.953-.484-.414.18-.82.375-1.219.594l-.406.234c-.398.234-.773.492-1.14.773-.595.446-.79 1.227-.555 1.93l.726 2.203a9.9 9.9 0 0 0-1.633 2.828l-2.273.47c-.727.148-1.305.71-1.39 1.444a13.432 13.432 0 0 0 0 3.188c.085.734.671 1.297 1.39 1.445l2.273.477a9.976 9.976 0 0 0 1.633 2.828l-.726 2.203c-.235.703-.04 1.484.554 1.93.367.273.742.531 1.14.765l.423.243c.39.218.797.414 1.21.593.68.29 1.454.07 1.954-.484l1.547-1.734c.531.086 1.078.132 1.633.132.554 0 1.101-.047 1.632-.132l1.547 1.734-.008.016ZM36.75 23.75a3.75 3.75 0 1 1 0 7.499 3.75 3.75 0 0 1 0-7.499Z" /></g><defs><clipPath id="bg-icon-gears_a"><path fill="#fff" transform="translate(.5)" d="M0 0h50v40H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 15"  id="bg-icon-group"><g clip-path="url(#bg-icon-group_a)"><path d="M.889 3.317A1.774 1.774 0 0 1 0 1.777C0 .798.797 0 1.778 0c.658 0 1.233.358 1.539.889h9.366A1.78 1.78 0 0 1 16 1.778c0 .658-.358 1.233-.889 1.539v7.589a1.778 1.778 0 1 1-2.428 2.427H3.317a1.778 1.778 0 1 1-2.428-2.427v-7.59Zm11.794-.65H3.317a1.78 1.78 0 0 1-.65.65v7.589c.27.155.494.38.65.65h9.366c.156-.27.38-.495.65-.65v-7.59a1.78 1.78 0 0 1-.65-.65ZM3.556 4.444c0-.491.397-.888.888-.888H8c.492 0 .889.397.889.888v2.667A.888.888 0 0 1 8 8H4.444a.888.888 0 0 1-.888-.889V4.444ZM7.11 8.89H8A1.78 1.78 0 0 0 9.778 7.11v-.889h1.778c.491 0 .888.397.888.89v2.666a.888.888 0 0 1-.888.889H8a.888.888 0 0 1-.889-.89V8.89Z" /></g><defs><clipPath id="bg-icon-group_a"><path fill="#fff" d="M0 0h16v14.222H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-image"><path d="M14.5 14h-13A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5ZM3.5 3.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM2 12h12V8.5l-2.735-2.735a.375.375 0 0 0-.53 0L6.5 10 4.765 8.265a.375.375 0 0 0-.53 0L2 10.5V12Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-info"><g clip-path="url(#bg-icon-info_a)"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm0 12a.748.748 0 0 1-.75-.75v-3.5c0-.416.334-.75.75-.75s.75.334.75.75v3.5c0 .416-.334.75-.75.75Zm1-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" /></g><defs><clipPath id="bg-icon-info_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-key"><g clip-path="url(#bg-icon-key_a)"><path d="M10.5 11A5.5 5.5 0 1 0 5 5.5c0 .584.09 1.15.26 1.678l-5.041 5.04A.75.75 0 0 0 0 12.75v2.5c0 .416.334.75.75.75h2.5c.416 0 .75-.334.75-.75V14h1.25c.416 0 .75-.334.75-.75V12h1.25c.2 0 .39-.078.531-.219l1.04-1.04c.529.168 1.095.259 1.679.259Zm1.25-8a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z" /></g><defs><clipPath id="bg-icon-key_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-left-arrow"><path d="M.335 7.191a1.148 1.148 0 0 0 0 1.621l5.714 5.726a1.143 1.143 0 0 0 1.618 0 1.148 1.148 0 0 0 0-1.621L3.9 9.145h10.958C15.49 9.145 16 8.633 16 8s-.51-1.145-1.143-1.145H3.903l3.76-3.772a1.148 1.148 0 0 0 0-1.62 1.143 1.143 0 0 0-1.617 0L.33 7.187l.004.003Z" /></symbol><symbol viewBox="0 0 30 24"  id="bg-icon-link"><path d="M26.678 12.548a6.776 6.776 0 0 0 0-9.585 6.777 6.777 0 0 0-8.733-.722l-.075.051a1.496 1.496 0 0 0-.347 2.09 1.5 1.5 0 0 0 2.091.348l.075-.052a3.773 3.773 0 0 1 4.866.403 3.777 3.777 0 0 1 0 5.344l-5.26 5.269a3.777 3.777 0 0 1-5.344 0 3.774 3.774 0 0 1-.403-4.866l.052-.075a1.5 1.5 0 0 0-.347-2.09 1.504 1.504 0 0 0-2.09.346l-.052.075a6.765 6.765 0 0 0 .717 8.729 6.776 6.776 0 0 0 9.586 0l5.264-5.265ZM2.322 11.452a6.776 6.776 0 0 0 0 9.586 6.777 6.777 0 0 0 8.733.721l.075-.051c.675-.483.83-1.42.346-2.09a1.5 1.5 0 0 0-2.09-.348l-.075.052a3.773 3.773 0 0 1-4.866-.403 3.783 3.783 0 0 1 0-5.349l5.26-5.264a3.78 3.78 0 0 1 5.747 4.87l-.052.076a1.499 1.499 0 0 0 .347 2.09c.67.478 1.612.324 2.09-.347l.052-.075A6.776 6.776 0 0 0 7.586 6.187l-5.264 5.265Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-mobile"><path d="M2.5 2c0-1.103.897-2 2-2h7c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2h-7c-1.103 0-2-.897-2-2V2ZM9 14a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2.5-12h-7v10h7V2Z" /></symbol><symbol viewBox="0 0 4 16"  id="bg-icon-more-actions"><path d="M2 11a1.75 1.75 0 1 0 0 3.5A1.75 1.75 0 0 0 2 11Zm0-5a1.75 1.75 0 1 0 0 3.5A1.75 1.75 0 0 0 2 6Zm1.75-3.25a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-notebook"><path d="M3.2 2.5c-.883 0-1.6.717-1.6 1.6v6.4h1.6V4.1h9.6v6.4h1.6V4.1c0-.882-.718-1.6-1.6-1.6H3.2ZM.48 11.3a.48.48 0 0 0-.48.48c0 1.06.86 1.92 1.92 1.92h12.16c1.06 0 1.92-.86 1.92-1.92a.48.48 0 0 0-.48-.48H.48Z" /></symbol><symbol viewBox="0 0 47 40"  id="bg-icon-open-folder"><g clip-path="url(#bg-icon-open-folder_a)"><path d="M31.019 37.5h3.76c.892 0 1.715-.469 2.161-1.242l8.773-15a2.496 2.496 0 0 0 .008-2.508 2.482 2.482 0 0 0-2.17-1.25h-31.33c-.893 0-1.716.469-2.162 1.242L4.7 27.898V7.5c0-.688.564-1.25 1.253-1.25h9.204c.329 0 .65.133.885.367l2.076 2.07a8.786 8.786 0 0 0 6.203 2.563h9.203c.69 0 1.254.563 1.254 1.25V15h3.76v-2.5c0-2.758-2.249-5-5.014-5h-9.203a5.021 5.021 0 0 1-3.548-1.46l-2.076-2.08A5.021 5.021 0 0 0 15.15 2.5H5.954C3.19 2.5.941 4.742.941 7.5v25c0 2.758 2.248 5 5.013 5H31.02Z" /></g><defs><clipPath id="bg-icon-open-folder_a"><path transform="translate(.941)" d="M0 0h45.116v40H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 10 16"  id="bg-icon-order-by"><path d="M7.529 6H1.471a.474.474 0 0 1-.332-.809L4.167 2.14a.47.47 0 0 1 .666 0L7.861 5.19A.474.474 0 0 1 7.529 6ZM1.471 10h6.058c.42 0 .629.51.332.809L4.833 13.86a.47.47 0 0 1-.666 0L1.139 10.81A.474.474 0 0 1 1.471 10Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-pallete"><g clip-path="url(#bg-icon-pallete_a)"><path d="M16 8v.084C15.988 9.225 14.95 10 13.81 10h-3.06a1.5 1.5 0 0 0-1.469 1.81c.066.318.203.624.338.934.19.431.378.86.378 1.312 0 .994-.675 1.897-1.669 1.938-.11.003-.219.006-.331.006A7.999 7.999 0 0 1 0 8a8 8 0 0 1 8-8 8 8 0 0 1 8 8ZM4 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm0-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-3a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm3 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" /></g><defs><clipPath id="bg-icon-pallete_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-plus"><path d="M14.857 6.286H9.714V1.143C9.714.512 9.203 0 8.571 0H7.43c-.631 0-1.143.512-1.143 1.143v5.143H1.143C.512 6.286 0 6.798 0 7.429V8.57c0 .632.512 1.143 1.143 1.143h5.143v5.143c0 .631.512 1.143 1.143 1.143H8.57c.632 0 1.143-.512 1.143-1.143V9.714h5.143c.631 0 1.143-.511 1.143-1.143V7.43c0-.631-.512-1.143-1.143-1.143Z" /></symbol><symbol viewBox="0 0 13 17"  id="bg-icon-receipt"><g clip-path="url(#bg-icon-receipt_a)"><path d="M.938.693a.749.749 0 0 1 .8.113L3 1.887 4.263.806a.749.749 0 0 1 .974 0L6.5 1.887 7.763.806a.749.749 0 0 1 .975 0L10 1.887 11.262.806a.749.749 0 0 1 1.238.569v14.5a.75.75 0 0 1-1.238.569L10 15.361l-1.262 1.082a.749.749 0 0 1-.975 0L6.5 15.361l-1.263 1.082a.749.749 0 0 1-.974 0L3 15.361l-1.262 1.082a.749.749 0 0 1-1.238-.57v-14.5a.75.75 0 0 1 .438-.68ZM3.5 5.125c-.275 0-.5.225-.5.5s.225.5.5.5h6c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-6Zm-.5 6.5c0 .275.225.5.5.5h6c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-6c-.275 0-.5.225-.5.5Zm.5-3.5c-.275 0-.5.225-.5.5s.225.5.5.5h6c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-6Z" /></g><defs><clipPath id="bg-icon-receipt_a"><path fill="#fff" transform="translate(.5 .625)" d="M0 0h12v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-recycle"><g clip-path="url(#bg-icon-recycle_a)"><path d="M5.46 1.41a2.994 2.994 0 0 1 5.08 0l1.207 1.927.844-.487a.747.747 0 0 1 .83.053c.241.184.348.497.27.79l-.732 2.732a.751.751 0 0 1-.918.531l-2.732-.731a.75.75 0 0 1-.181-1.372l.887-.512-1.171-1.872a.995.995 0 0 0-1.688 0l-.547.875a1.001 1.001 0 0 1-1.697-1.06l.547-.875Zm7.962 6.462a.999.999 0 0 1 1.362.328l.763 1.222a2.996 2.996 0 0 1-2.537 4.581L10 14v1a.75.75 0 0 1-1.281.531l-2-2a.747.747 0 0 1 0-1.06l2-2a.751.751 0 0 1 1.28.532v1h3.007a.996.996 0 0 0 .844-1.522l-.763-1.222a.999.999 0 0 1 .335-1.387ZM2.028 6.903l-.903-.522a.75.75 0 0 1 .181-1.372l2.731-.73c.4-.107.813.13.92.53l.73 2.728a.755.755 0 0 1-.268.791.742.742 0 0 1-.832.053l-.828-.478-1.61 2.575A.996.996 0 0 0 2.994 12H4a.999.999 0 1 1 0 2H2.994A2.994 2.994 0 0 1 .456 9.419l1.572-2.516Z" /></g><defs><clipPath id="bg-icon-recycle_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 17 17"  id="bg-icon-rotate-arrow"><path d="M4.428 5.96H6a.999.999 0 1 1 0 2H2c-.553 0-1-.446-1-1v-4a.999.999 0 1 1 2 0v1.6l.55-.55a7 7 0 0 1 9.9 0 7 7 0 0 1 0 9.9 7 7 0 0 1-9.9 0 1.001 1.001 0 0 1 1.416-1.415 5 5 0 1 0 0-7.072l-.538.537Z" /></symbol><symbol viewBox="0 0 16 17"  id="bg-icon-search"><path d="m15.782 13.835-3.115-3.116a.75.75 0 0 0-.532-.218h-.51a6.47 6.47 0 0 0 1.376-4A6.5 6.5 0 0 0 6.501 0 6.5 6.5 0 0 0 0 6.5 6.5 6.5 0 0 0 6.5 13c1.51 0 2.898-.512 4-1.374v.51c0 .2.079.39.22.53l3.115 3.116a.747.747 0 0 0 1.06 0l.884-.884a.754.754 0 0 0 .003-1.063ZM6.5 10.501c-2.21 0-4-1.788-4-4 0-2.21 1.788-4 4-4 2.21 0 4 1.787 4 4 0 2.209-1.787 4-4 4Z" /></symbol><symbol viewBox="0 0 16 17"  id="bg-icon-settings"><path d="m15.121 9.923-1.374-.794a6.214 6.214 0 0 0 0-2.264l1.374-.794a.39.39 0 0 0 .178-.452 8.033 8.033 0 0 0-1.765-3.051.388.388 0 0 0-.477-.074l-1.375.793a6.087 6.087 0 0 0-1.96-1.132V.57a.386.386 0 0 0-.304-.377 8.11 8.11 0 0 0-3.523 0 .386.386 0 0 0-.303.377v1.587A6.28 6.28 0 0 0 3.631 3.29L2.26 2.497a.383.383 0 0 0-.478.074A7.986 7.986 0 0 0 .018 5.623a.386.386 0 0 0 .177.451l1.375.794a6.214 6.214 0 0 0 0 2.264l-1.375.794a.39.39 0 0 0-.177.451 8.034 8.034 0 0 0 1.764 3.052.388.388 0 0 0 .478.074l1.374-.793c.577.496 1.242.88 1.961 1.132v1.587c0 .18.126.339.304.377a8.11 8.11 0 0 0 3.522 0 .386.386 0 0 0 .303-.377v-1.587a6.28 6.28 0 0 0 1.962-1.132l1.374.793c.158.09.355.062.477-.074a7.986 7.986 0 0 0 1.765-3.052.398.398 0 0 0-.18-.454Zm-7.464.654a2.584 2.584 0 0 1-2.581-2.58 2.584 2.584 0 0 1 2.58-2.58 2.584 2.584 0 0 1 2.581 2.58 2.584 2.584 0 0 1-2.58 2.58Z" /></symbol><symbol viewBox="0 0 18 17"  id="bg-icon-share"><g clip-path="url(#bg-icon-share_a)"><path d="M12.5 8.606V7.125c0-.275-.225-.5-.5-.5H9.047a3.546 3.546 0 0 0-3.385 2.487 2.946 2.946 0 0 1-.162-.987c0-1.935 1.566-3.5 3.5-3.5h3c.275 0 .5-.225.5-.5V2.644l3.313 2.98L12.5 8.607Zm-2-.481h.5v1.5c0 .553.447 1 1 1h.116a1 1 0 0 0 .668-.257l4.344-3.909a1.118 1.118 0 0 0 0-1.669L12.81.903a1.083 1.083 0 0 0-1.81.806v1.416H9.001c-2.763 0-5 2.237-5 5 0 1.887 1.081 3.097 1.997 3.778a6.102 6.102 0 0 0 1.15.678.53.53 0 0 0 .222.044h.078c.306 0 .556-.25.556-.556 0-.244-.165-.46-.362-.61l-.035-.025a.965.965 0 0 1-.156-.128c-.025-.025-.053-.05-.078-.081l-.075-.09a1.651 1.651 0 0 1-.156-.267 1.733 1.733 0 0 1-.135-.7c0-1.128.916-2.046 2.047-2.046H10.5v.003Zm-8.25-6.5A2.249 2.249 0 0 0 0 3.875v10.5a2.249 2.249 0 0 0 2.25 2.25h10.5a2.249 2.249 0 0 0 2.25-2.25v-2a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75v2c0 .415-.334.75-.75.75H2.25a.748.748 0 0 1-.75-.75v-10.5c0-.416.334-.75.75-.75h2c.416 0 .75-.335.75-.75a.748.748 0 0 0-.75-.75h-2Z" /></g><defs><clipPath id="bg-icon-share_a"><path fill="#fff" transform="translate(0 .625)" d="M0 0h18v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-shield"><g clip-path="url(#bg-icon-shield_a)"><path d="M7.5 0c.144 0 .287.031.419.09l5.884 2.497c.687.291 1.2.97 1.197 1.788-.016 3.1-1.29 8.772-6.678 11.35-.522.25-1.128.25-1.65 0C1.29 13.147.015 7.475 0 4.375a1.94 1.94 0 0 1 1.197-1.788L7.084.091A.995.995 0 0 1 7.5 0Zm0 2.087V13.9c4.312-2.088 5.472-6.71 5.5-9.481L7.5 2.088Z" /></g><defs><clipPath id="bg-icon-shield_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-sitemap"><path d="M5.778 3.083c0-.736.597-1.333 1.333-1.333H8.89c.736 0 1.333.597 1.333 1.333v1.778c0 .736-.597 1.333-1.333 1.333h-.222v1.112h4.222c.858 0 1.555.697 1.555 1.555v.889h.223c.736 0 1.333.597 1.333 1.333v1.778c0 .736-.597 1.333-1.333 1.333h-1.778a1.334 1.334 0 0 1-1.333-1.333v-1.778c0-.736.597-1.333 1.333-1.333h.222v-.889c0-.122-.1-.222-.222-.222H8.667V9.75h.222c.736 0 1.333.597 1.333 1.333v1.778c0 .736-.597 1.333-1.333 1.333H7.11a1.334 1.334 0 0 1-1.333-1.333v-1.778c0-.736.597-1.333 1.333-1.333h.222V8.639H3.111c-.122 0-.222.1-.222.222v.889h.222c.736 0 1.333.597 1.333 1.333v1.778c0 .736-.597 1.333-1.333 1.333H1.333A1.334 1.334 0 0 1 0 12.861v-1.778c0-.736.597-1.333 1.333-1.333h.223v-.889c0-.858.697-1.555 1.555-1.555h4.222V6.194h-.222a1.334 1.334 0 0 1-1.333-1.333V3.083Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-togheter"><g clip-path="url(#bg-icon-togheter_a)"><path d="M2 2.412c0-.313.126-.614.351-.835a1.21 1.21 0 0 1 1.698 0 1.172 1.172 0 0 1 0 1.67 1.21 1.21 0 0 1-1.698 0A1.172 1.172 0 0 1 2 2.413ZM3.6 7.18v1.603l1.275 1.255c.178.175.295.399.335.643l.38 2.237a.79.79 0 0 1-.657.906.8.8 0 0 1-.92-.647l-.358-2.115L1.67 9.108c-.3-.296-.47-.697-.47-1.115V5.824c0-.798.655-1.442 1.465-1.442.603 0 1.163.295 1.498.787l1.185 1.75.252.123V5.17c0-.435.358-.787.8-.787h3.2c.443 0 .8.352.8.787v1.876l.252-.123 1.186-1.753a1.805 1.805 0 0 1 1.497-.787c.81 0 1.465.644 1.465 1.442v2.169c0 .418-.168.82-.468 1.115l-1.985 1.954-.357 2.115a.8.8 0 0 1-.92.647.79.79 0 0 1-.658-.906l.38-2.237c.04-.244.158-.468.335-.643l1.275-1.255V7.18l-.474.702c-.116.172-.276.31-.463.401l-1.49.734a.73.73 0 0 1-.19.069.77.77 0 0 1-.197.02h-3.17a.806.806 0 0 1-.39-.092L4.54 8.281a1.206 1.206 0 0 1-.462-.402l-.475-.701-.003.002ZM.058 12.753l1.195-2.941 1.23 1.21-.94 2.315a.804.804 0 0 1-1.04.438.78.78 0 0 1-.445-1.022ZM12.8 1.231c.318 0 .623.124.848.346a1.172 1.172 0 0 1 0 1.67 1.21 1.21 0 0 1-1.697 0 1.172 1.172 0 0 1 0-1.67 1.21 1.21 0 0 1 .849-.346Zm1.947 8.58 1.196 2.942a.783.783 0 0 1-.445 1.024.804.804 0 0 1-1.04-.438l-.94-2.314 1.23-1.21v-.003Z" /></g><defs><clipPath id="bg-icon-togheter_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-update"><g clip-path="url(#bg-icon-update_a)"><path d="M4.466 4.466a5 5 0 0 1 7.04-.032L10.22 5.72A.751.751 0 0 0 10.75 7h4c.416 0 .75-.334.75-.75v-4a.749.749 0 0 0-1.281-.531l-1.3 1.3A6.998 6.998 0 0 0 1.4 5.669a1 1 0 0 0 1.884.665 4.95 4.95 0 0 1 1.182-1.868ZM.5 9.75v4a.75.75 0 0 0 1.281.531l1.3-1.3a6.998 6.998 0 0 0 9.869-.031 6.982 6.982 0 0 0 1.653-2.616 1 1 0 0 0-1.884-.665 4.95 4.95 0 0 1-1.181 1.868 5 5 0 0 1-7.041.032L5.78 10.28A.751.751 0 0 0 5.25 9h-4a.748.748 0 0 0-.75.75Z" /></g><defs><clipPath id="bg-icon-update_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-upload"><path d="M0 8c0-4.42 3.58-8 8-8s8 3.58 8 8-3.58 8-8 8-8-3.58-8-8Zm4.632.932 2.336-2.435v5.89c0 .43.345.774.774.774h.516a.772.772 0 0 0 .774-.774v-5.89l2.336 2.435c.3.313.8.32 1.106.013l.352-.355a.771.771 0 0 0 0-1.093l-4.278-4.28a.771.771 0 0 0-1.093 0l-4.28 4.28a.771.771 0 0 0 0 1.093l.35.355c.307.307.807.3 1.107-.013Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-user-check"><path d="M5.6 8.4a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Zm2.24.8h-.417a4.357 4.357 0 0 1-3.646 0H3.36A3.36 3.36 0 0 0 0 12.56v1.04a1.2 1.2 0 0 0 1.2 1.2H10a1.2 1.2 0 0 0 1.2-1.2v-1.04A3.36 3.36 0 0 0 7.84 9.2Zm8.075-3.21-.695-.703a.296.296 0 0 0-.42-.002l-2.62 2.6-1.137-1.145a.296.296 0 0 0-.42-.003l-.703.698a.296.296 0 0 0-.003.42l2.043 2.057a.296.296 0 0 0 .42.003l3.532-3.505a.299.299 0 0 0 .003-.42Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-user"><path d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm0 3.097a2.839 2.839 0 1 1 0 5.677 2.839 2.839 0 0 1 0-5.677Zm0 11.097a6.181 6.181 0 0 1-4.726-2.2c.607-1.142 1.794-1.93 3.178-1.93.077 0 .154.013.229.036.419.136.858.223 1.319.223.461 0 .903-.088 1.32-.223a.789.789 0 0 1 .228-.035c1.384 0 2.571.787 3.178 1.928A6.181 6.181 0 0 1 8 14.194Z" /></symbol>', t.insertBefore(o, t.lastChild);
  };
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", e) : e();
}
const Pt = Symbol("BgTabsRegister"), Xe = Symbol("BgTabsList"), Et = Symbol("BgTabs"), $1 = {
  prefix: Math.round(Math.random() * 1e10),
  current: 0
}, k1 = Symbol("IdInjectionKey"), ie = (e, t) => {
  const o = be(k1, $1);
  return [t, o.prefix, e || ++o.current].filter(Boolean).join("-");
}, Ye = () => {
  const e = f1(), t = e == null ? void 0 : e.vnode;
  if (!t)
    throw new Error("useVNode must be called within a component");
  return { vnode: t };
}, Ue = (e) => {
  const t = e.type;
  return (t == null ? void 0 : t.name) || (t == null ? void 0 : t.__name) || "unknown";
};
var Ze = function() {
  return Ze = Object.assign || function(t) {
    for (var o, n = 1, l = arguments.length; n < l; n++) {
      o = arguments[n];
      for (var s in o)
        Object.prototype.hasOwnProperty.call(o, s) && (t[s] = o[s]);
    }
    return t;
  }, Ze.apply(this, arguments);
};
function B1(e) {
  return e.toLowerCase();
}
var L1 = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], A1 = /[^A-Z0-9]+/gi;
function Z1(e, t) {
  t === void 0 && (t = {});
  for (var o = t.splitRegexp, n = o === void 0 ? L1 : o, l = t.stripRegexp, s = l === void 0 ? A1 : l, a = t.transform, i = a === void 0 ? B1 : a, c = t.delimiter, u = c === void 0 ? " " : c, p = dt(dt(e, n, "$1\0$2"), s, "\0"), h = 0, m = p.length; p.charAt(h) === "\0"; )
    h++;
  for (; p.charAt(m - 1) === "\0"; )
    m--;
  return p.slice(h, m).split("\0").map(i).join(u);
}
function dt(e, t, o) {
  return t instanceof RegExp ? e.replace(t, o) : t.reduce(function(n, l) {
    return n.replace(l, o);
  }, e);
}
function S1(e, t) {
  return t === void 0 && (t = {}), Z1(e, Ze({ delimiter: "." }, t));
}
function Se(e, t) {
  return t === void 0 && (t = {}), S1(e, Ze({ delimiter: "-" }, t));
}
const we = () => {
  const { vnode: e } = Ye(), t = e == null ? void 0 : e.key;
  if (!t)
    throw new Error(`<${Se(Ue(e))}> must have a key`);
  return t;
}, C1 = ["top", "right", "bottom", "left"], ft = ["start", "end"], pt = /* @__PURE__ */ C1.reduce((e, t) => e.concat(t, t + "-" + ft[0], t + "-" + ft[1]), []), mt = Math.min, ve = Math.max, Ce = Math.round, ee = (e) => ({
  x: e,
  y: e
}), H1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, I1 = {
  start: "end",
  end: "start"
};
function Qe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function xe(e) {
  return e.split("-")[0];
}
function Q(e) {
  return e.split("-")[1];
}
function N1(e) {
  return e === "x" ? "y" : "x";
}
function Rt(e) {
  return e === "y" ? "height" : "width";
}
function Je(e) {
  return ["top", "bottom"].includes(xe(e)) ? "y" : "x";
}
function Dt(e) {
  return N1(Je(e));
}
function V1(e, t, o) {
  o === void 0 && (o = !1);
  const n = Q(e), l = Dt(e), s = Rt(l);
  let a = l === "x" ? n === (o ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (a = ht(a)), [a, ht(a)];
}
function P1(e) {
  return e.replace(/start|end/g, (t) => I1[t]);
}
function ht(e) {
  return e.replace(/left|right|bottom|top/g, (t) => H1[t]);
}
function E1(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function R1(e) {
  return typeof e != "number" ? E1(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function He(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function gt(e, t, o) {
  let {
    reference: n,
    floating: l
  } = e;
  const s = Je(t), a = Dt(t), i = Rt(a), c = xe(t), u = s === "y", p = n.x + n.width / 2 - l.width / 2, h = n.y + n.height / 2 - l.height / 2, m = n[i] / 2 - l[i] / 2;
  let f;
  switch (c) {
    case "top":
      f = {
        x: p,
        y: n.y - l.height
      };
      break;
    case "bottom":
      f = {
        x: p,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: h
      };
      break;
    case "left":
      f = {
        x: n.x - l.width,
        y: h
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (Q(t)) {
    case "start":
      f[a] -= m * (o && u ? -1 : 1);
      break;
    case "end":
      f[a] += m * (o && u ? -1 : 1);
      break;
  }
  return f;
}
const D1 = async (e, t, o) => {
  const {
    placement: n = "bottom",
    strategy: l = "absolute",
    middleware: s = [],
    platform: a
  } = o, i = s.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let u = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: l
  }), {
    x: p,
    y: h
  } = gt(u, n, c), m = n, f = {}, d = 0;
  for (let M = 0; M < i.length; M++) {
    const {
      name: L,
      fn: I
    } = i[M], {
      x: C,
      y: N,
      data: F,
      reset: H
    } = await I({
      x: p,
      y: h,
      initialPlacement: n,
      placement: m,
      strategy: l,
      middlewareData: f,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (p = C ?? p, h = N ?? h, f = {
      ...f,
      [L]: {
        ...f[L],
        ...F
      }
    }, H && d <= 50) {
      d++, typeof H == "object" && (H.placement && (m = H.placement), H.rects && (u = H.rects === !0 ? await a.getElementRects({
        reference: e,
        floating: t,
        strategy: l
      }) : H.rects), {
        x: p,
        y: h
      } = gt(u, m, c)), M = -1;
      continue;
    }
  }
  return {
    x: p,
    y: h,
    placement: m,
    strategy: l,
    middlewareData: f
  };
};
async function T1(e, t) {
  var o;
  t === void 0 && (t = {});
  const {
    x: n,
    y: l,
    platform: s,
    rects: a,
    elements: i,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: h = "floating",
    altBoundary: m = !1,
    padding: f = 0
  } = Qe(t, e), d = R1(f), L = i[m ? h === "floating" ? "reference" : "floating" : h], I = He(await s.getClippingRect({
    element: (o = await (s.isElement == null ? void 0 : s.isElement(L))) == null || o ? L : L.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(i.floating)),
    boundary: u,
    rootBoundary: p,
    strategy: c
  })), C = h === "floating" ? {
    ...a.floating,
    x: n,
    y: l
  } : a.reference, N = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(i.floating)), F = await (s.isElement == null ? void 0 : s.isElement(N)) ? await (s.getScale == null ? void 0 : s.getScale(N)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, H = He(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: C,
    offsetParent: N,
    strategy: c
  }) : C);
  return {
    top: (I.top - H.top + d.top) / F.y,
    bottom: (H.bottom - I.bottom + d.bottom) / F.y,
    left: (I.left - H.left + d.left) / F.x,
    right: (H.right - I.right + d.right) / F.x
  };
}
function O1(e, t, o) {
  return (e ? [...o.filter((l) => Q(l) === e), ...o.filter((l) => Q(l) !== e)] : o.filter((l) => xe(l) === l)).filter((l) => e ? Q(l) === e || (t ? P1(l) !== l : !1) : !0);
}
const z1 = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(t) {
      var o, n, l;
      const {
        rects: s,
        middlewareData: a,
        placement: i,
        platform: c,
        elements: u
      } = t, {
        crossAxis: p = !1,
        alignment: h,
        allowedPlacements: m = pt,
        autoAlignment: f = !0,
        ...d
      } = Qe(e, t), M = h !== void 0 || m === pt ? O1(h || null, f, m) : m, L = await T1(t, d), I = ((o = a.autoPlacement) == null ? void 0 : o.index) || 0, C = M[I];
      if (C == null)
        return {};
      const N = V1(C, s, await (c.isRTL == null ? void 0 : c.isRTL(u.floating)));
      if (i !== C)
        return {
          reset: {
            placement: M[0]
          }
        };
      const F = [L[xe(C)], L[N[0]], L[N[1]]], H = [...((n = a.autoPlacement) == null ? void 0 : n.overflows) || [], {
        placement: C,
        overflows: F
      }], $e = M[I + 1];
      if ($e)
        return {
          data: {
            index: I + 1,
            overflows: H
          },
          reset: {
            placement: $e
          }
        };
      const A = H.map((K) => {
        const fe = Q(K.placement);
        return [K.placement, fe && p ? (
          // Check along the mainAxis and main crossAxis side.
          K.overflows.slice(0, 2).reduce((u1, d1) => u1 + d1, 0)
        ) : (
          // Check only the mainAxis.
          K.overflows[0]
        ), K.overflows];
      }).sort((K, fe) => K[1] - fe[1]), de = ((l = A.filter((K) => K[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        Q(K[0]) ? 2 : 3
      ).every((fe) => fe <= 0))[0]) == null ? void 0 : l[0]) || A[0][0];
      return de !== i ? {
        data: {
          index: I + 1,
          overflows: H
        },
        reset: {
          placement: de
        }
      } : {};
    }
  };
};
async function F1(e, t) {
  const {
    placement: o,
    platform: n,
    elements: l
  } = e, s = await (n.isRTL == null ? void 0 : n.isRTL(l.floating)), a = xe(o), i = Q(o), c = Je(o) === "y", u = ["left", "top"].includes(a) ? -1 : 1, p = s && c ? -1 : 1, h = Qe(t, e);
  let {
    mainAxis: m,
    crossAxis: f,
    alignmentAxis: d
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...h
  };
  return i && typeof d == "number" && (f = i === "end" ? d * -1 : d), c ? {
    x: f * p,
    y: m * u
  } : {
    x: m * u,
    y: f * p
  };
}
const j1 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var o, n;
      const {
        x: l,
        y: s,
        placement: a,
        middlewareData: i
      } = t, c = await F1(t, e);
      return a === ((o = i.offset) == null ? void 0 : o.placement) && (n = i.arrow) != null && n.alignmentOffset ? {} : {
        x: l + c.x,
        y: s + c.y,
        data: {
          ...c,
          placement: a
        }
      };
    }
  };
};
function X(e) {
  return et(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function E(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ne(e) {
  var t;
  return (t = (et(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function et(e) {
  return e instanceof Node || e instanceof E(e).Node;
}
function Y(e) {
  return e instanceof Element || e instanceof E(e).Element;
}
function q(e) {
  return e instanceof HTMLElement || e instanceof E(e).HTMLElement;
}
function vt(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof E(e).ShadowRoot;
}
function Me(e) {
  const {
    overflow: t,
    overflowX: o,
    overflowY: n,
    display: l
  } = z(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + o) && !["inline", "contents"].includes(l);
}
function G1(e) {
  return ["table", "td", "th"].includes(X(e));
}
function tt(e) {
  const t = ot(), o = z(e);
  return o.transform !== "none" || o.perspective !== "none" || (o.containerType ? o.containerType !== "normal" : !1) || !t && (o.backdropFilter ? o.backdropFilter !== "none" : !1) || !t && (o.filter ? o.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (o.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (o.contain || "").includes(n));
}
function K1(e) {
  let t = ce(e);
  for (; q(t) && !Ie(t); ) {
    if (tt(t))
      return t;
    t = ce(t);
  }
  return null;
}
function ot() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ie(e) {
  return ["html", "body", "#document"].includes(X(e));
}
function z(e) {
  return E(e).getComputedStyle(e);
}
function Ne(e) {
  return Y(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ce(e) {
  if (X(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    vt(e) && e.host || // Fallback.
    ne(e)
  );
  return vt(t) ? t.host : t;
}
function Tt(e) {
  const t = ce(e);
  return Ie(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : q(t) && Me(t) ? t : Tt(t);
}
function Te(e, t, o) {
  var n;
  t === void 0 && (t = []), o === void 0 && (o = !0);
  const l = Tt(e), s = l === ((n = e.ownerDocument) == null ? void 0 : n.body), a = E(l);
  return s ? t.concat(a, a.visualViewport || [], Me(l) ? l : [], a.frameElement && o ? Te(a.frameElement) : []) : t.concat(l, Te(l, [], o));
}
function Ot(e) {
  const t = z(e);
  let o = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const l = q(e), s = l ? e.offsetWidth : o, a = l ? e.offsetHeight : n, i = Ce(o) !== s || Ce(n) !== a;
  return i && (o = s, n = a), {
    width: o,
    height: n,
    $: i
  };
}
function zt(e) {
  return Y(e) ? e : e.contextElement;
}
function ae(e) {
  const t = zt(e);
  if (!q(t))
    return ee(1);
  const o = t.getBoundingClientRect(), {
    width: n,
    height: l,
    $: s
  } = Ot(t);
  let a = (s ? Ce(o.width) : o.width) / n, i = (s ? Ce(o.height) : o.height) / l;
  return (!a || !Number.isFinite(a)) && (a = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: a,
    y: i
  };
}
const W1 = /* @__PURE__ */ ee(0);
function Ft(e) {
  const t = E(e);
  return !ot() || !t.visualViewport ? W1 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function q1(e, t, o) {
  return t === void 0 && (t = !1), !o || t && o !== E(e) ? !1 : t;
}
function ye(e, t, o, n) {
  t === void 0 && (t = !1), o === void 0 && (o = !1);
  const l = e.getBoundingClientRect(), s = zt(e);
  let a = ee(1);
  t && (n ? Y(n) && (a = ae(n)) : a = ae(e));
  const i = q1(s, o, n) ? Ft(s) : ee(0);
  let c = (l.left + i.x) / a.x, u = (l.top + i.y) / a.y, p = l.width / a.x, h = l.height / a.y;
  if (s) {
    const m = E(s), f = n && Y(n) ? E(n) : n;
    let d = m.frameElement;
    for (; d && n && f !== m; ) {
      const M = ae(d), L = d.getBoundingClientRect(), I = z(d), C = L.left + (d.clientLeft + parseFloat(I.paddingLeft)) * M.x, N = L.top + (d.clientTop + parseFloat(I.paddingTop)) * M.y;
      c *= M.x, u *= M.y, p *= M.x, h *= M.y, c += C, u += N, d = E(d).frameElement;
    }
  }
  return He({
    width: p,
    height: h,
    x: c,
    y: u
  });
}
function X1(e) {
  let {
    rect: t,
    offsetParent: o,
    strategy: n
  } = e;
  const l = q(o), s = ne(o);
  if (o === s)
    return t;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, i = ee(1);
  const c = ee(0);
  if ((l || !l && n !== "fixed") && ((X(o) !== "body" || Me(s)) && (a = Ne(o)), q(o))) {
    const u = ye(o);
    i = ae(o), c.x = u.x + o.clientLeft, c.y = u.y + o.clientTop;
  }
  return {
    width: t.width * i.x,
    height: t.height * i.y,
    x: t.x * i.x - a.scrollLeft * i.x + c.x,
    y: t.y * i.y - a.scrollTop * i.y + c.y
  };
}
function Y1(e) {
  return Array.from(e.getClientRects());
}
function jt(e) {
  return ye(ne(e)).left + Ne(e).scrollLeft;
}
function U1(e) {
  const t = ne(e), o = Ne(e), n = e.ownerDocument.body, l = ve(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), s = ve(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let a = -o.scrollLeft + jt(e);
  const i = -o.scrollTop;
  return z(n).direction === "rtl" && (a += ve(t.clientWidth, n.clientWidth) - l), {
    width: l,
    height: s,
    x: a,
    y: i
  };
}
function Q1(e, t) {
  const o = E(e), n = ne(e), l = o.visualViewport;
  let s = n.clientWidth, a = n.clientHeight, i = 0, c = 0;
  if (l) {
    s = l.width, a = l.height;
    const u = ot();
    (!u || u && t === "fixed") && (i = l.offsetLeft, c = l.offsetTop);
  }
  return {
    width: s,
    height: a,
    x: i,
    y: c
  };
}
function J1(e, t) {
  const o = ye(e, !0, t === "fixed"), n = o.top + e.clientTop, l = o.left + e.clientLeft, s = q(e) ? ae(e) : ee(1), a = e.clientWidth * s.x, i = e.clientHeight * s.y, c = l * s.x, u = n * s.y;
  return {
    width: a,
    height: i,
    x: c,
    y: u
  };
}
function bt(e, t, o) {
  let n;
  if (t === "viewport")
    n = Q1(e, o);
  else if (t === "document")
    n = U1(ne(e));
  else if (Y(t))
    n = J1(t, o);
  else {
    const l = Ft(e);
    n = {
      ...t,
      x: t.x - l.x,
      y: t.y - l.y
    };
  }
  return He(n);
}
function Gt(e, t) {
  const o = ce(e);
  return o === t || !Y(o) || Ie(o) ? !1 : z(o).position === "fixed" || Gt(o, t);
}
function e0(e, t) {
  const o = t.get(e);
  if (o)
    return o;
  let n = Te(e, [], !1).filter((i) => Y(i) && X(i) !== "body"), l = null;
  const s = z(e).position === "fixed";
  let a = s ? ce(e) : e;
  for (; Y(a) && !Ie(a); ) {
    const i = z(a), c = tt(a);
    !c && i.position === "fixed" && (l = null), (s ? !c && !l : !c && i.position === "static" && !!l && ["absolute", "fixed"].includes(l.position) || Me(a) && !c && Gt(e, a)) ? n = n.filter((p) => p !== a) : l = i, a = ce(a);
  }
  return t.set(e, n), n;
}
function t0(e) {
  let {
    element: t,
    boundary: o,
    rootBoundary: n,
    strategy: l
  } = e;
  const a = [...o === "clippingAncestors" ? e0(t, this._c) : [].concat(o), n], i = a[0], c = a.reduce((u, p) => {
    const h = bt(t, p, l);
    return u.top = ve(h.top, u.top), u.right = mt(h.right, u.right), u.bottom = mt(h.bottom, u.bottom), u.left = ve(h.left, u.left), u;
  }, bt(t, i, l));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function o0(e) {
  const {
    width: t,
    height: o
  } = Ot(e);
  return {
    width: t,
    height: o
  };
}
function n0(e, t, o) {
  const n = q(t), l = ne(t), s = o === "fixed", a = ye(e, !0, s, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = ee(0);
  if (n || !n && !s)
    if ((X(t) !== "body" || Me(l)) && (i = Ne(t)), n) {
      const u = ye(t, !0, s, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else
      l && (c.x = jt(l));
  return {
    x: a.left + i.scrollLeft - c.x,
    y: a.top + i.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function yt(e, t) {
  return !q(e) || z(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Kt(e, t) {
  const o = E(e);
  if (!q(e))
    return o;
  let n = yt(e, t);
  for (; n && G1(n) && z(n).position === "static"; )
    n = yt(n, t);
  return n && (X(n) === "html" || X(n) === "body" && z(n).position === "static" && !tt(n)) ? o : n || K1(e) || o;
}
const l0 = async function(e) {
  let {
    reference: t,
    floating: o,
    strategy: n
  } = e;
  const l = this.getOffsetParent || Kt, s = this.getDimensions;
  return {
    reference: n0(t, await l(o), n),
    floating: {
      x: 0,
      y: 0,
      ...await s(o)
    }
  };
};
function s0(e) {
  return z(e).direction === "rtl";
}
const a0 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: X1,
  getDocumentElement: ne,
  getClippingRect: t0,
  getOffsetParent: Kt,
  getElementRects: l0,
  getClientRects: Y1,
  getDimensions: o0,
  getScale: ae,
  isElement: Y,
  isRTL: s0
}, i0 = z1, c0 = (e, t, o) => {
  const n = /* @__PURE__ */ new Map(), l = {
    platform: a0,
    ...o
  }, s = {
    ...l.platform,
    _c: n
  };
  return D1(e, t, {
    ...l,
    platform: s
  });
};
function r0(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function _t(e) {
  if (r0(e)) {
    const t = e.$el;
    return et(t) && X(t) === "#comment" ? null : t;
  }
  return e;
}
function Wt(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function wt(e, t) {
  const o = Wt(e);
  return Math.round(t * o) / o;
}
function u0(e, t, o) {
  o === void 0 && (o = {});
  const n = o.whileElementsMounted, l = w(() => {
    var A;
    return (A = r(o.open)) != null ? A : !0;
  }), s = w(() => r(o.middleware)), a = w(() => {
    var A;
    return (A = r(o.placement)) != null ? A : "bottom";
  }), i = w(() => {
    var A;
    return (A = r(o.strategy)) != null ? A : "absolute";
  }), c = w(() => {
    var A;
    return (A = r(o.transform)) != null ? A : !0;
  }), u = w(() => _t(e.value)), p = w(() => _t(t.value)), h = S(0), m = S(0), f = S(i.value), d = S(a.value), M = p1({}), L = S(!1), I = w(() => {
    const A = {
      position: f.value,
      left: "0",
      top: "0"
    };
    if (!p.value)
      return A;
    const Pe = wt(p.value, h.value), de = wt(p.value, m.value);
    return c.value ? {
      ...A,
      transform: "translate(" + Pe + "px, " + de + "px)",
      ...Wt(p.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: f.value,
      left: Pe + "px",
      top: de + "px"
    };
  });
  let C;
  function N() {
    u.value == null || p.value == null || c0(u.value, p.value, {
      middleware: s.value,
      placement: a.value,
      strategy: i.value
    }).then((A) => {
      h.value = A.x, m.value = A.y, f.value = A.strategy, d.value = A.placement, M.value = A.middlewareData, L.value = !0;
    });
  }
  function F() {
    typeof C == "function" && (C(), C = void 0);
  }
  function H() {
    if (F(), n === void 0) {
      N();
      return;
    }
    if (u.value != null && p.value != null) {
      C = n(u.value, p.value, N);
      return;
    }
  }
  function $e() {
    l.value || (L.value = !1);
  }
  return D([s, a, i], N, {
    flush: "sync"
  }), D([u, p], H, {
    flush: "sync"
  }), D(l, $e, {
    flush: "sync"
  }), St() && Ct(F), {
    x: se(h),
    y: se(m),
    strategy: se(f),
    placement: se(d),
    middlewareData: se(M),
    isPositioned: se(L),
    floatingStyles: I,
    update: N
  };
}
function d0(e) {
  return St() ? (Ct(e), !0) : !1;
}
function qt(e) {
  return typeof e == "function" ? e() : r(e);
}
const Xt = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const f0 = Object.prototype.toString, p0 = (e) => f0.call(e) === "[object Object]", Be = () => {
}, m0 = /* @__PURE__ */ h0();
function h0() {
  var e, t;
  return Xt && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function pe(e) {
  var t;
  const o = qt(e);
  return (t = o == null ? void 0 : o.$el) != null ? t : o;
}
const Yt = Xt ? window : void 0;
function Re(...e) {
  let t, o, n, l;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([o, n, l] = e, t = Yt) : [t, o, n, l] = e, !t)
    return Be;
  Array.isArray(o) || (o = [o]), Array.isArray(n) || (n = [n]);
  const s = [], a = () => {
    s.forEach((p) => p()), s.length = 0;
  }, i = (p, h, m, f) => (p.addEventListener(h, m, f), () => p.removeEventListener(h, m, f)), c = D(
    () => [pe(t), qt(l)],
    ([p, h]) => {
      if (a(), !p)
        return;
      const m = p0(h) ? { ...h } : h;
      s.push(
        ...o.flatMap((f) => n.map((d) => i(p, f, d, m)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    c(), a();
  };
  return d0(u), u;
}
let xt = !1;
function g0(e, t, o = {}) {
  const { window: n = Yt, ignore: l = [], capture: s = !0, detectIframe: a = !1 } = o;
  if (!n)
    return Be;
  m0 && !xt && (xt = !0, Array.from(n.document.body.children).forEach((m) => m.addEventListener("click", Be)), n.document.documentElement.addEventListener("click", Be));
  let i = !0;
  const c = (m) => l.some((f) => {
    if (typeof f == "string")
      return Array.from(n.document.querySelectorAll(f)).some((d) => d === m.target || m.composedPath().includes(d));
    {
      const d = pe(f);
      return d && (m.target === d || m.composedPath().includes(d));
    }
  }), p = [
    Re(n, "click", (m) => {
      const f = pe(e);
      if (!(!f || f === m.target || m.composedPath().includes(f))) {
        if (m.detail === 0 && (i = !c(m)), !i) {
          i = !0;
          return;
        }
        t(m);
      }
    }, { passive: !0, capture: s }),
    Re(n, "pointerdown", (m) => {
      const f = pe(e);
      i = !c(m) && !!(f && !m.composedPath().includes(f));
    }, { passive: !0 }),
    a && Re(n, "blur", (m) => {
      setTimeout(() => {
        var f;
        const d = pe(e);
        ((f = n.document.activeElement) == null ? void 0 : f.tagName) === "IFRAME" && !(d != null && d.contains(n.document.activeElement)) && t(m);
      }, 0);
    })
  ].filter(Boolean);
  return () => p.forEach((m) => m());
}
const v0 = (e, t, o) => {
  const n = S(!1), l = () => {
    n.value = !1;
  };
  g0(e, (i) => {
    var c;
    (c = t.value) != null && c.contains(i.target) || (n.value = !1);
  });
  const { floatingStyles: s, isPositioned: a } = u0(e, t, {
    open: n,
    placement: "bottom-end",
    middleware: [
      i0({
        allowedPlacements: ["bottom-end", "bottom-start", "top-end", "top-start"]
      }),
      j1(({ rects: i }) => typeof (o == null ? void 0 : o.offset) == "function" ? o.offset(i) : (o == null ? void 0 : o.offset) || 0)
    ]
  });
  return D(a, (i) => {
    var c;
    i && ((c = t.value) == null || c.focus());
  }), {
    floatingStyles: s,
    opened: n,
    close: l
  };
}, le = (e, t) => (Array.from(new Set(t)).forEach((o) => {
  (e[o] === null || e[o] === void 0) && m1(`Missing required prop: "${String(o)}"`);
}), e), nt = ({
  injectionKey: e,
  items: t,
  initialActiveItem: o
}) => {
  const n = S(), l = (f) => t.value.findIndex((d) => d.key === f), s = () => t.value[0], a = () => t.value[t.value.length - 1], i = (f) => l(f.key) === 0, c = (f) => l(f.key) === t.value.length - 1, u = () => {
    n.value = !n.value || c(n.value) ? s() : t.value[l(n.value.key) + 1];
  }, p = () => {
    n.value = !n.value || i(n.value) ? a() : t.value[l(n.value.key) - 1];
  }, h = (f) => {
    f ? n.value = t.value.find((d) => d.key === f) : n.value = s();
  }, m = (f) => {
    n.value = t.value[f];
  };
  return o && h(o), te(e, {
    activeItem: n,
    activateByIndex: m,
    next: u,
    prev: p,
    activate: h
  }), {
    activateByIndex: m,
    activeItem: n,
    next: u,
    prev: p,
    activate: h,
    items: t
  };
}, Ve = ({ injectionKey: e, parentName: t }) => {
  const o = ue({ injectionKey: e, parentName: t }), n = w(() => {
    var i;
    return ((i = o.activeItem.value) == null ? void 0 : i.key) === l;
  }), l = we(), s = () => o.activate(l);
  return {
    ...o,
    toggle: () => {
      n.value ? o.activeItem.value = void 0 : s();
    },
    activate: s,
    isActive: n
  };
}, ue = ({ injectionKey: e, parentName: t }) => {
  const o = be(e, null), { vnode: n } = Ye(), l = Ue(n);
  if (!o)
    throw new Error(
      `<${Se(l)}> must be used inside a <${Se(t)}> component`
    );
  return o;
};
function b0(e, t = (o) => o) {
  return e.slice().sort((o, n) => {
    const l = t(o), s = t(n);
    if (l === null || s === null)
      return 0;
    const a = l.compareDocumentPosition(s);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
const y0 = (e) => b0(e, (t) => t.vnode.el), lt = ({ injectionKey: e, onRegister: t }) => {
  const o = S([]), n = ie(), a = {
    items: o,
    getIndex: (i) => o.value.findIndex((c) => c.key === i),
    register: (i, c) => {
      var m;
      const p = `${Ue(c)}-${n}-${i}`, h = {
        key: i,
        id: p,
        vnode: c,
        ref: (m = c.component) == null ? void 0 : m.exposed
      };
      return o.value = y0([...o.value, h]), t == null || t(p, i), {
        id: p,
        unregister: () => {
          o.value = o.value.filter((f) => f.key !== i);
        }
      };
    }
  };
  return te(e, a), a;
}, st = ({ injectionKey: e, parentName: t }) => {
  const o = ue({
    injectionKey: e,
    parentName: t
  }), { vnode: n } = Ye();
  if (!n)
    throw new Error("useInjectList must be called within a component");
  const l = we(), s = S();
  return h1(() => {
    const { unregister: a, id: i } = o.register(l, n);
    s.value = i, g1(() => a());
  }), { ...o, id: s };
}, _0 = { class: "bg-tabs" }, w0 = { role: "tablist" }, x0 = /* @__PURE__ */ _({
  __name: "BgTabs",
  props: {
    type: { default: "line" },
    activeTab: {}
  },
  emits: ["update:activeTab"],
  setup(e, { emit: t }) {
    const o = e, n = t, l = Ht({}), { items: s } = lt({
      injectionKey: Pt,
      onRegister: (c, u) => {
        l[u] = c, i(o.activeTab);
      }
    }), { activeItem: a, activate: i } = nt({
      injectionKey: Xe,
      items: s
    });
    return te(Et, {
      useIdByKey: (c) => v1(l, c)
    }), D(
      () => o.activeTab,
      (c) => {
        c && l[c] && i(c);
      }
    ), D(a, (c) => {
      n("update:activeTab", c == null ? void 0 : c.key);
    }), (c, u) => (v(), P("div", _0, [
      T("div", w0, [
        y(c.$slots, "tabs", {}, void 0, !0)
      ]),
      y(c.$slots, "panels", {}, void 0, !0)
    ]));
  }
});
const B = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [n, l] of t)
    o[n] = l;
  return o;
}, el = /* @__PURE__ */ B(x0, [["__scopeId", "data-v-7a5cd42f"]]), M0 = "_focus-visible-outline_8w4bv_1", $0 = "_focus-visible-inline_8w4bv_7", k0 = "_font_8w4bv_18", Oe = {
  focusVisibleOutline: M0,
  focusVisibleInline: $0,
  font: k0
}, B0 = /* @__PURE__ */ _({
  __name: "BgReset",
  props: {
    is: {}
  },
  setup(e) {
    const t = e;
    return le(t, ["is"]), (o, n) => (v(), b(It(t.is), null, {
      default: g(() => [
        y(o.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
});
const k = /* @__PURE__ */ B(B0, [["__scopeId", "data-v-4e90bdcf"]]), L0 = _({
  name: "BgTab"
}), A0 = /* @__PURE__ */ _({
  ...L0,
  setup(e) {
    const t = S(), { id: o } = st({
      parentName: "BgTabs",
      injectionKey: Pt
    }), { next: n, prev: l, activate: s, isActive: a } = Ve({
      parentName: "BgTabs",
      injectionKey: Xe
    });
    return D(a, (i) => {
      var c;
      i && ((c = t.value) == null || c.$el.focus());
    }), (i, c) => (v(), b(r(k), {
      is: "button",
      ref_key: "buttonRef",
      ref: t,
      role: "tab",
      class: x([r(Oe).focusVisibleInline, r(Oe).font]),
      tabindex: r(a) ? 0 : -1,
      "aria-controls": r(o),
      "aria-selected": r(a),
      "data-state": r(a) ? "selected" : "unselected",
      onKeydown: [
        c[0] || (c[0] = ge((u) => r(n)(), ["right"])),
        c[1] || (c[1] = ge((u) => r(l)(), ["left"]))
      ],
      onClick: r(s)
    }, {
      default: g(() => [
        y(i.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class", "tabindex", "aria-controls", "aria-selected", "data-state", "onClick"]));
  }
});
const tl = /* @__PURE__ */ B(A0, [["__scopeId", "data-v-9f4aff6c"]]), Z0 = ["id", "tabindex"], S0 = _({
  name: "BgTabPanel"
}), C0 = /* @__PURE__ */ _({
  ...S0,
  setup(e) {
    const { isActive: t } = Ve({
      parentName: "BgTabs",
      injectionKey: Xe
    }), { useIdByKey: o } = ue({
      parentName: "BgTabs",
      injectionKey: Et
    }), n = we(), l = o(n);
    return (s, a) => (v(), P("div", re({
      id: r(l),
      class: r(Oe).focusVisibleInline,
      role: "tabpanel",
      tabindex: r(t) ? 0 : -1
    }, { "data-state": r(t) ? "active" : "inactive" }), [
      r(t) ? y(s.$slots, "default", { key: 0 }, void 0, !0) : J("", !0)
    ], 16, Z0));
  }
});
const ol = /* @__PURE__ */ B(C0, [["__scopeId", "data-v-5e9d981b"]]), Ut = Symbol("BgSidebarRegister"), Qt = Symbol("BgSidebarList"), Jt = Symbol("BgSidebarGroupContext"), H0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 104 20"
}, I0 = /* @__PURE__ */ b1('<title>Transfeera Logo</title><path fill="#1FD1C2" fill-rule="evenodd" d="M36.844 12.958v-5.25h-1.461a.69.69 0 0 1-.685-.684.69.69 0 0 1 .685-.683h4.462a.69.69 0 0 1 .684.683.69.69 0 0 1-.684.684H38.4v5.25a.69.69 0 0 1-.684.683h-.202a.677.677 0 0 1-.669-.683M45.444 13.253l-1.213-2.206h-1.136v1.833c0 .42-.341.76-.762.761h-.03a.763.763 0 0 1-.763-.761V6.341h3.421c1.524 0 2.472.994 2.472 2.36 0 1.274-.824 1.973-1.617 2.16l.964 1.615a.755.755 0 0 1-.653 1.15.76.76 0 0 1-.684-.373m.373-4.565c0-.606-.467-.978-1.089-.978H43.08v1.973h1.648c.622-.003 1.089-.375 1.089-.995M53.452 13.144l-.28-.73h-3.125l-.28.73a.74.74 0 0 1-.716.497h-.108c-.528 0-.918-.543-.716-1.04l2.068-5.36a1.44 1.44 0 0 1 1.338-.916c.59.005 1.12.368 1.337.917l2.067 5.357a.762.762 0 0 1-.715 1.041h-.109c-.357.001-.653-.185-.761-.496m-1.835-5.25-1.136 3.138h2.27zM60.791 13.175l-3.156-4.302v3.99a.77.77 0 0 1-.779.778.77.77 0 0 1-.777-.778v-5.53c.004-.546.447-.99.995-.993.38 0 .737.178.964.481l3.033 4.1V7.118a.77.77 0 0 1 .777-.777.77.77 0 0 1 .778.777v5.591a.935.935 0 0 1-.933.932 1.16 1.16 0 0 1-.902-.466M63.963 11.933c.233-.342.684-.404 1.027-.188.52.346 1.132.53 1.757.526.855 0 1.275-.373 1.275-.807 0-1.274-4.214-.373-4.214-3.122 0-1.212 1.057-2.237 2.783-2.237.84 0 1.57.171 2.193.527a.734.734 0 0 1 .232 1.056.73.73 0 0 1-.933.202 3.14 3.14 0 0 0-1.617-.42c-.653 0-1.026.28-1.026.715 0 1.15 4.198.373 4.198 3.107 0 1.336-.964 2.345-2.923 2.345-1.058 0-1.883-.263-2.52-.683a.685.685 0 0 1-.232-1.021M70.65 12.958V6.34h4.493a.69.69 0 0 1 .685.683.69.69 0 0 1-.685.684H72.22v1.537h1.461a.69.69 0 0 1 .685.684.69.69 0 0 1-.684.684h-1.462v2.345a.69.69 0 0 1-.685.683h-.188a.683.683 0 0 1-.697-.683M76.9 13.641v-7.3h4.495a.69.69 0 0 1 .684.683.69.69 0 0 1-.684.684H78.47v1.537h1.462a.69.69 0 0 1 .684.684.69.69 0 0 1-.684.684H78.47v1.662h2.924a.69.69 0 0 1 .684.683.69.69 0 0 1-.684.683zM83.292 13.641v-7.3h4.493a.69.69 0 0 1 .685.683.69.69 0 0 1-.685.684h-2.923v1.537h1.462a.69.69 0 0 1 .684.684.69.69 0 0 1-.684.684h-1.462v1.662h2.924a.69.69 0 0 1 .684.683.69.69 0 0 1-.684.683zM93.601 13.253l-1.213-2.206h-1.135v1.833c0 .42-.341.76-.762.761h-.031a.763.763 0 0 1-.762-.761V6.341h3.421c1.524 0 2.472.994 2.472 2.36 0 1.274-.824 1.973-1.617 2.16l.964 1.615a.755.755 0 0 1-.653 1.15.75.75 0 0 1-.684-.373m.373-4.565c0-.606-.466-.978-1.088-.978h-1.649v1.973h1.649c.622-.003 1.088-.375 1.088-.995M101.609 13.144l-.279-.73h-3.126l-.28.73a.74.74 0 0 1-.715.497h-.14c-.527 0-.917-.543-.715-1.04l2.068-5.36a1.44 1.44 0 0 1 1.338-.916c.591.005 1.12.368 1.337.917l2.067 5.357a.762.762 0 0 1-.715 1.041h-.108a.76.76 0 0 1-.732-.496m-1.85-5.25-1.135 3.138h2.286zM11.647 18.833V3.495H9.314v15.338a1.174 1.174 0 0 0 1.168 1.166 1.165 1.165 0 0 0 1.165-1.166M25.642 18.833V5.243H23.31v13.59a1.174 1.174 0 0 0 1.167 1.166 1.165 1.165 0 0 0 1.165-1.166M18.645 14.81v4.024A1.174 1.174 0 0 0 19.812 20a1.174 1.174 0 0 0 1.167-1.166v-2.378a1.945 1.945 0 0 0-1.555-1.91c-.126-.031-.78-.19-.78.264M6.982 12.884v-9.39H4.649v9.11q1.166.117 2.333.28M4.65 15.286v3.547a1.174 1.174 0 0 0 1.167 1.166 1.174 1.174 0 0 0 1.167-1.166v-1.916c0-.997-.75-1.834-1.742-1.942-.08-.016-.593-.03-.593.31" clip-rule="evenodd"></path><path fill="#1FD1C2" fill-rule="evenodd" d="M6.982 3.495a1.167 1.167 0 0 1 2.332 0h2.333A3.497 3.497 0 0 0 8.148 0 3.497 3.497 0 0 0 4.65 3.495zM20.977 5.242a1.167 1.167 0 0 1 2.333 0h2.332a3.497 3.497 0 0 0-3.499-3.495 3.497 3.497 0 0 0-3.498 3.495zM25.02 11.719v2.347q2.401.327 4.758.792a.436.436 0 0 0 .513-.419 2.25 2.25 0 0 0-1.866-2.206q-1.68-.281-3.405-.514M8.242 11.502c-2.563.26-5.112.65-7.635 1.165a.76.76 0 0 0-.607.745 1.433 1.433 0 0 0 1.726 1.398c1.82-.357 3.67-.652 5.52-.87a1.634 1.634 0 0 0 1.462-1.63v-.388c-.016-.25-.218-.45-.466-.42M15.644 11.129c-1.54 0-3.08.046-4.603.14v2.33a75 75 0 0 1 9.89.048c.948.077 1.757-.684 1.757-1.647v-.17a.42.42 0 0 0-.373-.42 86 86 0 0 0-6.671-.281" clip-rule="evenodd"></path><path fill="#1FD1C2" fill-rule="evenodd" d="M8.692 3.605a.508.508 0 0 0-.832-.393l-.007.006-.003.003a.77.77 0 0 0-.075 1.12q.195.213.395.413a.306.306 0 0 0 .521-.216zM22.424 5.109a.775.775 0 0 0-1.025-.18c-1.548.976-5.929 3.162-10.375.186v1.816a9.9 9.9 0 0 0 4.804 1.234c.665 0 1.329-.064 1.983-.188 1.976-.371 3.555-1.203 4.413-1.736a.773.773 0 0 0 .2-1.132" clip-rule="evenodd"></path><path fill="#1FD1C2" fill-rule="evenodd" d="M20.977 6.208v-.966h-2.332v1.773a11 11 0 0 0 2.332-.807M18.645 9.748v2.266c.793.155 1.57.31 2.332.481V8.392a.346.346 0 0 0-.466-.323 13 13 0 0 1-.788.257 1.485 1.485 0 0 0-1.078 1.422" clip-rule="evenodd"></path><path fill="#1FD1C2" fill-rule="evenodd" d="M20.86 1.747h2.56c1.226 0 2.22.992 2.22 2.216v1.28h-1.793l-1.709-2.089-1.79 2.088h-1.71V3.963a2.215 2.215 0 0 1 2.222-2.216M6.863 0h2.56c1.226 0 2.219.992 2.219 2.216v1.279h-1.79L8.143 1.407l-1.79 2.088H4.645V2.216C4.645.992 5.638 0 6.863 0" clip-rule="evenodd"></path>', 6), N0 = [
  I0
];
function V0(e, t) {
  return v(), P("svg", H0, [...N0]);
}
const Mt = { render: V0 }, at = ({ to: e }) => {
  let t;
  if (!w(() => typeof e == "string" && e.startsWith("http")).value)
    try {
      t = M1({ to: e });
    } catch (n) {
      console.warn('You need vue-router installed to use the "to" property.', n);
    }
  return t;
}, it = /* @__PURE__ */ _({
  __name: "BgLink",
  props: {
    to: {},
    activeClass: {},
    routerLink: {}
  },
  setup(e) {
    const t = e, o = t.routerLink ? S(t.routerLink) : S(), n = w(() => typeof t.to == "string" && t.to.startsWith("http"));
    return !n.value && !t.routerLink && (o.value = at({ to: t.to })), (l, s) => {
      var a, i, c;
      return n.value ? (v(), b(r(k), re({
        key: 0,
        is: "a"
      }, l.$attrs, {
        href: l.to,
        target: "_blank"
      }), {
        default: g(() => [
          y(l.$slots, "default")
        ]),
        _: 3
      }, 16, ["href"])) : (v(), b(r(k), {
        key: 1,
        is: "a",
        class: x({ [l.activeClass || ""]: (a = r(o)) == null ? void 0 : a.isActive }),
        href: (i = r(o)) == null ? void 0 : i.href,
        onClick: (c = r(o)) == null ? void 0 : c.navigate
      }, {
        default: g(() => [
          y(l.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "href", "onClick"]));
    };
  }
}), P0 = /* @__PURE__ */ _({
  __name: "BgSidebar",
  props: {
    logoTo: {}
  },
  setup(e) {
    const t = e, { items: o } = lt({
      injectionKey: Ut,
      onRegister() {
        n(0);
      }
    }), { activateByIndex: n } = nt({
      injectionKey: Qt,
      items: o
    }), l = S();
    return t.logoTo && (l.value = at({ to: t.logoTo })), (s, a) => (v(), b(r(k), { is: "nav" }, {
      default: g(() => [
        $(r(k), { is: "header" }, {
          default: g(() => [
            y(s.$slots, "logo", {}, () => [
              s.logoTo ? (v(), b(it, {
                key: 0,
                "router-link": l.value,
                to: s.logoTo
              }, {
                default: g(() => [
                  $(r(Mt), { height: "20px" })
                ]),
                _: 1
              }, 8, ["router-link", "to"])) : (v(), b(r(Mt), {
                key: 1,
                height: "20px"
              }))
            ], !0)
          ]),
          _: 3
        }),
        $(r(k), { is: "ul" }, {
          default: g(() => [
            y(s.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), E0 = {}, R0 = {
  $style: E0
}, $t = /* @__PURE__ */ B(P0, [["__cssModules", R0], ["__scopeId", "data-v-b34823e6"]]);
var me = /* @__PURE__ */ ((e) => (e.Xs = "xs", e.Sm = "sm", e.Md = "md", e))(me || {});
const ze = {
  grey: {
    white: "#ffffff",
    light: "#cdd6de",
    semiLight: "#b2c1cd",
    normal: "#9dadbb",
    semiDark: "#72818d",
    dark: "#4d565d"
  },
  blue: {
    light: "#6cc8f7",
    semiLight: "#00aef3",
    normal: "#0096ed",
    semiDark: "#006cb2",
    dark: "#004876"
  },
  green: {
    light: "#7de1d6",
    semiLight: "#1fd1c2",
    normal: "#1fbfae",
    semiDark: "#009182",
    dark: "#005f56"
  },
  yellow: {
    light: "#ffdda0",
    semiLight: "#ffcb71",
    normal: "#ffb748",
    semiDark: "#c68b2e",
    dark: "#845c1e"
  },
  red: {
    light: "#ff7d9c",
    semiLight: "#ff3569",
    normal: "#ff003a",
    semiDark: "#cb0026",
    dark: "#870017"
  },
  bg: { backgroundAlt: "#f5f5f7", background: "#f8fafa" }
}, D0 = { regular: "400", semiBold: "600", bold: "700" }, Fe = {
  0: "12px",
  1: "14px",
  2: "16px",
  3: "18px",
  4: "20px",
  5: "24px",
  6: "32px",
  7: "40px",
  8: "48px",
  9: "64px"
}, W = {
  h1: {
    regular: "400 64px/72px Nunito",
    bold: "700 64px/72px Nunito",
    semiBold: "600 64px/72px Nunito"
  },
  h2: {
    regular: "400 48px/56px Nunito",
    bold: "700 48px/56px Nunito",
    semiBold: "600 48px/56px Nunito"
  },
  h3: {
    regular: "400 40px/48px Nunito",
    bold: "700 40px/48px Nunito",
    semiBold: "600 40px/48px Nunito"
  },
  h4: {
    regular: "400 32px/40px Nunito",
    bold: "700 32px/40px Nunito",
    semiBold: "600 32px/40px Nunito"
  },
  h5: {
    regular: "400 24px/32px Nunito",
    bold: "700 24px/32px Nunito",
    semiBold: "600 24px/32px Nunito"
  },
  h6: {
    regular: "400 20px/28px Nunito",
    bold: "700 20px/28px Nunito",
    semiBold: "600 20px/28px Nunito"
  },
  bodyLg: {
    regular: "400 18px/26px Nunito",
    bold: "700 18px/26px Nunito",
    semiBold: "600 18px/26px Nunito"
  },
  bodyMd: {
    regular: "400 16px/24px Nunito",
    bold: "700 16px/24px Nunito",
    semiBold: "600 16px/24px Nunito"
  },
  bodySm: {
    regular: "400 14px/22px Nunito",
    bold: "700 14px/22px Nunito",
    semiBold: "600 14px/22px Nunito"
  },
  small: {
    regular: "600 12px/20px Nunito",
    bold: "700 12px/20px Nunito",
    semiBold: "600 12px/20px Nunito"
  }
}, kt = {
  "3xSm": "4px",
  "2xSm": "8px",
  xSm: "16px",
  sm: "32px",
  md: "48px",
  lg: "64px",
  xLg: "80px",
  "2xLg": "128px",
  "3xLg": "256px"
}, Bt = { none: "0", sm: "4px", md: "8px", lg: "16px", xLg: "32px", "2xLg": "64px" }, j = {
  "2xSm": "4px",
  xSm: "8px",
  sm: "16px",
  md: "32px",
  lg: "64px",
  xLg: "128px",
  "2xLg": "256px"
};
var Z = /* @__PURE__ */ ((e) => (e.GreyWhite = "grey-white", e.GreyLight = "grey-light", e.GreySemiLight = "grey-semi-light", e.GreyNormal = "grey-normal", e.GreySemiDark = "grey-semi-dark", e.GreyDark = "grey-dark", e.BlueLight = "blue-light", e.BlueSemiLight = "blue-semi-light", e.BlueNormal = "blue-normal", e.BlueSemiDark = "blue-semi-dark", e.BlueDark = "blue-dark", e.GreenLight = "green-light", e.GreenSemiLight = "green-semi-light", e.GreenNormal = "green-normal", e.GreenSemiDark = "green-semi-dark", e.GreenDark = "green-dark", e.YellowLight = "yellow-light", e.YellowSemiLight = "yellow-semi-light", e.YellowNormal = "yellow-normal", e.YellowSemiDark = "yellow-semi-dark", e.YellowDark = "yellow-dark", e.RedLight = "red-light", e.RedSemiLight = "red-semi-light", e.RedNormal = "red-normal", e.RedSemiDark = "red-semi-dark", e.RedDark = "red-dark", e.BgBackgroundAlt = "bg-background-alt", e.BgBackground = "bg-background", e))(Z || {});
const T0 = () => {
  const e = ze, t = {};
  for (const o in e) {
    const n = e[o];
    for (const l in n) {
      const s = `${o}-${Se(l)}`;
      t[s] = n[l];
    }
  }
  return t;
}, V = (e) => {
  const t = T0()[e];
  return t || console.error("Color " + e + " not found"), t;
}, O0 = (e) => ({
  [Z.YellowLight]: V(Z.YellowSemiDark),
  [Z.GreyLight]: V(Z.GreySemiDark),
  [Z.GreyWhite]: V(Z.GreySemiDark),
  [Z.BgBackground]: V(Z.GreySemiDark),
  [Z.BgBackgroundAlt]: V(Z.GreySemiDark)
})[e] || V(Z.GreyWhite), z0 = ["aria-hidden", "role"], F0 = { key: 0 }, j0 = ["href"], G0 = /* @__PURE__ */ _({
  __name: "BgIcon",
  props: {
    name: {},
    size: { default: me.Sm },
    color: { default: "grey-semi-dark" },
    title: {}
  },
  setup(e) {
    oe((a) => ({
      "86ebe1d2": o.value,
      64152328: s.value.color
    }));
    const t = e;
    le(t, ["name"]);
    const o = w(() => ({
      [me.Xs]: "8px",
      [me.Sm]: "16px",
      [me.Md]: "24px"
    })[t.size]), n = w(() => `#bg-icon-${t.name}`), l = w(() => !!t.title), s = w(() => ({
      color: V(t.color)
    }));
    return (a, i) => (v(), P("svg", {
      "aria-hidden": l.value ? "false" : "true",
      role: l.value ? "img" : void 0
    }, [
      a.title ? (v(), P("title", F0, G(a.title), 1)) : J("", !0),
      T("use", { href: n.value }, null, 8, j0)
    ], 8, z0));
  }
}), K0 = {}, W0 = {
  $style: K0
}, _e = /* @__PURE__ */ B(G0, [["__cssModules", W0], ["__scopeId", "data-v-bf09893e"]]), q0 = /* @__PURE__ */ _({
  render: () => $(_e, {
    name: "alert",
    color: "red-semi-light"
  }, null)
}), X0 = /* @__PURE__ */ _({
  render: () => $(mn, {
    size: "sm",
    color: "green-semi-light"
  }, {
    default: () => [O("Novo")]
  })
}), Y0 = /* @__PURE__ */ _({
  __name: "BgSidebarDecoration",
  props: {
    type: {}
  },
  setup(e) {
    const t = e, o = w(() => ({
      alert: q0,
      new: X0
    })[t.type]);
    return (n, l) => (v(), b(It(o.value), {
      class: x(n.$style.decoration)
    }, null, 8, ["class"]));
  }
}), U0 = "_decoration_1s8ys_2", Q0 = {
  decoration: U0
}, J0 = {
  $style: Q0
}, e1 = /* @__PURE__ */ B(Y0, [["__cssModules", J0], ["__scopeId", "data-v-95113f13"]]), eo = _({
  name: "BgSidebarGroup"
}), to = /* @__PURE__ */ _({
  ...eo,
  props: {
    label: {},
    icon: {},
    decoration: {}
  },
  setup(e) {
    const t = e, o = S(!1), { id: n } = st({
      parentName: $t.name,
      injectionKey: Ut
    }), { isActive: l, toggle: s, activate: a } = Ve({
      parentName: $t.name,
      injectionKey: Qt
    });
    return D(l, (i) => {
      o.value = i;
    }), le(t, ["label"]), te(Jt, {
      activate: a
    }), (i, c) => (v(), b(r(k), { is: "li" }, {
      default: g(() => [
        $(r(k), {
          is: "button",
          "aria-expanded": o.value,
          "aria-controls": r(n),
          class: x(i.$style.group),
          onClick: r(s)
        }, {
          default: g(() => [
            T("span", {
              class: x(i.$style.label)
            }, [
              $(r(_e), {
                class: x(o.value ? i.$style.caretDown : i.$style.caretRight),
                name: "caret-down",
                size: "xs"
              }, null, 8, ["class"]),
              O(" " + G(i.label), 1)
            ], 2),
            T("span", null, [
              i.decoration ? (v(), b(e1, {
                key: 0,
                type: i.decoration
              }, null, 8, ["type"])) : i.icon ? (v(), b(r(_e), {
                key: 1,
                name: i.icon.name,
                class: x(i.$style.icon)
              }, null, 8, ["name", "class"])) : J("", !0)
            ])
          ]),
          _: 1
        }, 8, ["aria-expanded", "aria-controls", "class", "onClick"]),
        $(r(k), {
          is: "ul",
          id: r(n),
          hidden: !o.value,
          class: x([i.$style.items])
        }, {
          default: g(() => [
            y(i.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["id", "hidden", "class"])
      ]),
      _: 3
    }));
  }
}), oo = "_caret-right_1tota_14", no = "_caret-down_1tota_19", lo = "_group_1tota_24", so = "_icon_1tota_40", ao = "_label_1tota_45", io = {
  caretRight: oo,
  caretDown: no,
  group: lo,
  icon: so,
  label: ao
}, co = {
  $style: io
}, ro = /* @__PURE__ */ B(to, [["__cssModules", co], ["__scopeId", "data-v-21d114dd"]]), uo = /* @__PURE__ */ _({
  __name: "BgSidebarItem",
  props: {
    label: {},
    decoration: {},
    to: {}
  },
  setup(e) {
    const t = e, o = at({ to: t.to }), { activate: n } = ue({
      parentName: ro.name,
      injectionKey: Jt
    });
    return le(t, ["label"]), o && D(o.isActive, (l) => {
      l && n();
    }), (l, s) => (v(), b(r(k), { is: "li" }, {
      default: g(() => [
        $(r(it), {
          to: l.to,
          "active-class": l.$style.active,
          class: x(l.$style.content),
          "router-link": r(o)
        }, {
          default: g(() => [
            O(G(l.label) + " ", 1),
            l.decoration ? (v(), b(e1, {
              key: 0,
              type: l.decoration
            }, null, 8, ["type"])) : J("", !0)
          ]),
          _: 1
        }, 8, ["to", "active-class", "class", "router-link"])
      ]),
      _: 1
    }));
  }
}), fo = "_content_13vqd_8", po = "_active_13vqd_27", mo = {
  content: fo,
  active: po
}, ho = {
  $style: mo
}, nl = /* @__PURE__ */ B(uo, [["__cssModules", ho], ["__scopeId", "data-v-be553028"]]);
var je = /* @__PURE__ */ ((e) => (e.GreenSemiLight = "green-semi-light", e))(je || {}), Ge = /* @__PURE__ */ ((e) => (e.Sm = "sm", e))(Ge || {});
const go = /* @__PURE__ */ _({
  __name: "BgAvatar",
  props: {
    fullName: {},
    color: { default: je.GreenSemiLight },
    size: { default: Ge.Sm }
  },
  setup(e) {
    oe((s) => ({
      "5016fb68": n.value.backgroundColor,
      "394358cc": n.value.color,
      "094c0790": l.value.height,
      "1faac6d6": l.value.width
    }));
    const t = e;
    le(t, ["fullName"]);
    const o = w(() => {
      const s = t.fullName.split(" ").filter((c) => c.trim() !== ""), a = s[0], i = s.length > 1 ? s[s.length - 1] : "";
      return a.charAt(0).toUpperCase() + (i == null ? void 0 : i.charAt(0).toUpperCase());
    }), n = w(() => ({
      [je.GreenSemiLight]: {
        backgroundColor: ze.green.semiLight,
        color: ze.grey.white
      }
    })[t.color]), l = w(() => ({
      [Ge.Sm]: {
        fontSize: Fe[2],
        fontWeight: D0.semiBold,
        width: "40px",
        height: "40px"
      }
    })[t.size]);
    return (s, a) => (v(), b(r(k), {
      is: "div",
      role: "img",
      "aria-label": `Avatar para ${s.fullName}`
    }, {
      default: g(() => [
        O(G(o.value), 1)
      ]),
      _: 1
    }, 8, ["aria-label"]));
  }
}), vo = {}, bo = {
  $style: vo
}, Lt = /* @__PURE__ */ B(go, [["__cssModules", bo], ["__scopeId", "data-v-c2c29505"]]), t1 = Symbol("Menu"), Ke = Symbol("MenuItemGroup"), yo = /* @__PURE__ */ _({
  __name: "BgTransition",
  props: {
    type: {}
  },
  setup(e) {
    return (t, o) => (v(), b(y1, {
      name: `bg-${t.type}`
    }, {
      default: g(() => [
        y(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["name"]));
  }
});
const _o = ["id", "role", "aria-labelledby"], wo = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "BgPopover",
  props: {
    offset: { type: [Number, Function] },
    role: {},
    focusTriggerOnClose: { type: Boolean }
  },
  emits: ["close"],
  setup(e, { expose: t, emit: o }) {
    const n = e, l = S(null), s = S(null), a = ie("bg-popover-button"), i = ie("bg-popover"), { floatingStyles: c, opened: u, close: p } = v0(s, l, {
      offset: n.offset
    }), h = o;
    t({ close: p });
    const m = () => {
      var d;
      (d = s.value) == null || d.focus();
    };
    _1(() => {
      u.value || (h("close"), n.focusTriggerOnClose && m());
    });
    const f = Ht({
      id: a,
      "aria-controls": i,
      "aria-haspopup": n.role,
      "aria-expanded": u,
      onClick: () => u.value = !u.value,
      ref: (d) => {
        s.value = (d == null ? void 0 : d.$el) ?? d;
      }
    });
    return (d, M) => (v(), P(ke, null, [
      y(d.$slots, "button", Nt(Vt(f)), void 0, !0),
      $(r(yo), { type: "fade" }, {
        default: g(() => [
          r(u) ? (v(), P("div", re({ key: 0 }, d.$attrs, {
            id: r(i),
            ref_key: "floating",
            ref: l,
            role: d.role,
            style: r(c),
            "aria-labelledby": r(a)
          }), [
            y(d.$slots, "default", {}, void 0, !0)
          ], 16, _o)) : J("", !0)
        ]),
        _: 3
      })
    ], 64));
  }
}), xo = {}, Mo = {
  $style: xo
}, o1 = /* @__PURE__ */ B(wo, [["__cssModules", Mo], ["__scopeId", "data-v-e80ed2dd"]]), $o = /* @__PURE__ */ _({
  __name: "BgMenu",
  props: {
    offset: { type: [Number, Function] }
  },
  setup(e) {
    const t = S();
    return te(t1, { close: () => {
      var n;
      (n = t.value) == null || n.close();
    } }), (n, l) => (v(), b(r(o1), {
      ref_key: "popover",
      ref: t,
      offset: n.offset,
      role: "menu"
    }, {
      button: g((s) => [
        y(n.$slots, "button", Nt(Vt(s)), void 0, !0)
      ]),
      default: g(() => [
        T("ul", null, [
          y(n.$slots, "default", {}, void 0, !0)
        ]),
        y(n.$slots, "footer", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["offset"]));
  }
}), ko = {}, Bo = {
  $style: ko
}, Lo = /* @__PURE__ */ B($o, [["__cssModules", Bo], ["__scopeId", "data-v-d84904a8"]]), Ao = /* @__PURE__ */ _({
  __name: "BgMenuItem",
  props: {
    borderTop: { type: Boolean },
    onClick: { type: Function },
    to: {}
  },
  setup(e) {
    oe((i) => ({
      d503bad8: s
    }));
    const t = be(t1), o = be(Ke, null), n = o == null ? void 0 : o.title, l = (o == null ? void 0 : o.level) ?? 0, s = `calc(${j.sm} + ${l + (o && !n ? -1 : 0)} * ${j.sm})`;
    if (!t)
      throw new Error("<bg-menu-item> must be used inside a <bg-menu> component");
    const { close: a } = t;
    return (i, c) => (v(), b(r(k), {
      is: "li",
      role: "presentation",
      class: x({
        [i.$style.borderTop]: i.borderTop,
        [i.$style.clickable]: i.onClick || i.to
      })
    }, {
      default: g(() => [
        i.to ? (v(), b(r(it), {
          key: 0,
          role: "menuitem",
          to: i.to,
          class: x([i.$style.content]),
          onClick: c[0] || (c[0] = ct((u) => r(a)(), ["stop"]))
        }, {
          default: g(() => [
            y(i.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["to", "class"])) : i.onClick ? (v(), b(r(k), {
          key: 1,
          is: "button",
          role: "menuitem",
          class: x([i.$style.content]),
          onClick: c[1] || (c[1] = ct((u) => {
            i.onClick(), r(a)();
          }, ["stop"]))
        }, {
          default: g(() => [
            y(i.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["class"])) : (v(), b(r(k), {
          key: 2,
          is: "div",
          class: x([i.$style.content])
        }, {
          default: g(() => [
            y(i.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["class"]))
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Zo = "_content_1ilhc_6", So = "_border-top_1ilhc_21", Co = "_border-bottom_1ilhc_25", Ho = "_clickable_1ilhc_29", Io = {
  content: Zo,
  borderTop: So,
  borderBottom: Co,
  clickable: Ho
}, No = {
  $style: Io
}, We = /* @__PURE__ */ B(Ao, [["__cssModules", No], ["__scopeId", "data-v-d33c4e53"]]), Vo = ["id"], Po = /* @__PURE__ */ _({
  __name: "BgMenuItemGroup",
  props: {
    title: {}
  },
  setup(e) {
    const t = e, { level: o } = be(Ke, { level: 0 }), n = ie();
    return te(Ke, {
      level: o + 1,
      title: t.title
    }), (l, s) => (v(), b(r(k), {
      is: "li",
      role: "menuitem",
      "aria-labelledby": r(n),
      class: x({
        [l.$style.group]: !0
      })
    }, {
      default: g(() => [
        l.title ? (v(), P("div", {
          key: 0,
          id: r(n),
          class: x(l.$style.title)
        }, [
          $(r(l1), {
            type: "small",
            color: "grey-semi-light"
          }, {
            default: g(() => [
              O(G(l.title), 1)
            ]),
            _: 1
          })
        ], 10, Vo)) : J("", !0),
        $(r(k), { is: "ul" }, {
          default: g(() => [
            y(l.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["aria-labelledby", "class"]));
  }
}), Eo = "_title_1lk9u_2", Ro = "_group_1lk9u_7", Do = "_border-top_1lk9u_12", To = "_border-bottom_1lk9u_16", Oo = {
  title: Eo,
  group: Ro,
  borderTop: Do,
  borderBottom: To
}, zo = {
  $style: Oo
}, At = /* @__PURE__ */ B(Po, [["__cssModules", zo], ["__scopeId", "data-v-178d0f6d"]]), Fo = /* @__PURE__ */ _({
  __name: "BgMenuItemFooter",
  props: {
    borderTop: { type: Boolean },
    onClick: { type: Function },
    to: {}
  },
  setup(e) {
    const t = e;
    return (o, n) => (v(), b(r(We), re(t, {
      class: o.$style.item
    }), {
      default: g(() => [
        y(o.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), jo = "_item_x2ini_2", Go = {
  item: jo
}, Ko = {
  $style: Go
}, Wo = /* @__PURE__ */ B(Fo, [["__cssModules", Ko], ["__scopeId", "data-v-4c56d0f6"]]), qo = { "aria-label": "Main Navigation" }, Zt = 64, Xo = /* @__PURE__ */ _({
  __name: "BgTopbar",
  props: {
    profileMenuItemGroups: {},
    profileFullName: {},
    footerMenuItems: {}
  },
  setup(e) {
    return oe((o) => ({
      c535ce68: Zt
    })), le(e, ["profileFullName", "profileMenuItemGroups"]), (o, n) => (v(), P("nav", qo, [
      $(r(k), { is: "ul" }, {
        default: g(() => [
          y(o.$slots, "left", {}, void 0, !0)
        ]),
        _: 3
      }),
      $(r(k), { is: "ul" }, {
        default: g(() => [
          y(o.$slots, "right", {}, void 0, !0),
          $(r(tn), null, {
            default: g(() => [
              $(r(Lo), {
                offset: (l) => 1 + (Zt - l.reference.height) / 2
              }, {
                button: g((l) => [
                  $(r(k), re({ is: "button" }, l), {
                    default: g(() => [
                      $(r(Lt), { "full-name": o.profileFullName }, null, 8, ["full-name"])
                    ]),
                    _: 2
                  }, 1040)
                ]),
                footer: g(() => [
                  (v(!0), P(ke, null, Ee(o.footerMenuItems, (l) => (v(), b(r(Wo), {
                    key: l.label,
                    to: l.to,
                    onClick: l.onClick
                  }, {
                    default: g(() => [
                      O(G(l.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "onClick"]))), 128))
                ]),
                default: g(() => [
                  $(r(At), null, {
                    default: g(() => [
                      $(r(We), null, {
                        default: g(() => [
                          T("div", {
                            class: x(o.$style.avatarHeader)
                          }, [
                            $(r(Lt), { "full-name": o.profileFullName }, null, 8, ["full-name"]),
                            O(" " + G(o.profileFullName), 1)
                          ], 2)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (v(!0), P(ke, null, Ee(o.profileMenuItemGroups, (l) => (v(), b(r(At), {
                    key: l.label,
                    title: l.label
                  }, {
                    default: g(() => [
                      (v(!0), P(ke, null, Ee(l.items, (s) => (v(), b(r(We), {
                        key: s.label,
                        to: s.to,
                        onClick: s.onClick
                      }, {
                        default: g(() => [
                          O(G(s.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "onClick"]))), 128))
                    ]),
                    _: 2
                  }, 1032, ["title"]))), 128))
                ]),
                _: 1
              }, 8, ["offset"])
            ]),
            _: 1
          })
        ]),
        _: 3
      })
    ]));
  }
}), Yo = "_avatar-header_fg9nk_2", Uo = {
  avatarHeader: Yo
};
const Qo = {
  $style: Uo
}, ll = /* @__PURE__ */ B(Xo, [["__cssModules", Qo], ["__scopeId", "data-v-c2bc2f9d"]]);
const Jo = {};
function en(e, t) {
  return v(), P("li", null, [
    y(e.$slots, "default", {}, void 0, !0)
  ]);
}
const tn = /* @__PURE__ */ B(Jo, [["render", en], ["__scopeId", "data-v-0a1fbbf0"]]), on = (e, t) => {
  const o = e[t];
  return o ? typeof o == "function" ? o() : Promise.resolve(o) : new Promise((n, l) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(l.bind(null, new Error("Unknown variable dynamic import: " + t)));
  });
}, nn = ["src"], sl = /* @__PURE__ */ _({
  __name: "BgIllustration",
  props: {
    name: {}
  },
  setup(e) {
    const t = e, o = S();
    return le(t, ["name"]), D(
      () => t.name,
      (n) => {
        on(/* @__PURE__ */ Object.assign({ "./illustrations/boy-explaining.svg": () => import("./boy-explaining-dbaacfae.js"), "./illustrations/boy-holding-security-badge.svg": () => import("./boy-holding-security-badge-b8632124.js"), "./illustrations/boy-talking.svg": () => import("./boy-talking-44303a53.js"), "./illustrations/girl-exchanging-currency.svg": () => import("./girl-exchanging-currency-51cb1e18.js"), "./illustrations/girl-laptop-deadline.svg": () => import("./girl-laptop-deadline-7b15f613.js"), "./illustrations/girl-looking-pix-alert.svg": () => import("./girl-looking-pix-alert-1bd92bea.js") }), `./illustrations/${n}.svg`).then((l) => {
          o.value = l.default;
        });
      },
      {
        immediate: !0
      }
    ), (n, l) => (v(), P("img", {
      src: o.value,
      alt: ""
    }, null, 8, nn));
  }
});
var R = /* @__PURE__ */ ((e) => (e.small = "small", e.BodySm = "body-sm", e.BodyMd = "body-md", e.BodyLg = "body-lg", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e))(R || {}), n1 = /* @__PURE__ */ ((e) => (e.Regular = "regular", e.Bold = "bold", e.SemiBold = "semi-bold", e))(n1 || {});
const ln = /* @__PURE__ */ _({
  __name: "BgText",
  props: {
    is: {},
    type: { default: R.BodySm },
    weight: { default: n1.Regular },
    color: {}
  },
  setup(e) {
    oe((a) => ({
      "68206c8c": l.value,
      "9c41c150": s.value
    }));
    const t = e, o = () => ({
      [R.small]: {
        is: t.is || "small",
        font: W.small
      },
      [R.BodySm]: {
        is: t.is || "p",
        font: W.bodySm
      },
      [R.BodyMd]: {
        is: t.is || "p",
        font: W.bodyMd
      },
      [R.BodyLg]: {
        is: t.is || "p",
        font: W.bodyLg
      },
      [R.H1]: {
        is: t.is || "h1",
        font: W.h1
      },
      [R.H2]: {
        is: t.is || "h2",
        font: W.h2
      },
      [R.H3]: {
        is: t.is || "h3",
        font: W.h3
      },
      [R.H4]: {
        is: t.is || "h4",
        font: W.h4
      },
      [R.H5]: {
        is: t.is || "h5",
        font: W.h5
      },
      [R.H6]: {
        is: t.is || "h6",
        font: W.h6
      }
    }), n = w(() => o()[t.type].is), l = w(
      () => o()[t.type].font[w1(t.weight)]
    ), s = w(() => t.color ? V(t.color) : void 0);
    return (a, i) => (v(), b(r(k), {
      is: n.value,
      class: x(a.$style.font)
    }, {
      default: g(() => [
        y(a.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["is", "class"]));
  }
}), sn = "_font_o5f7b_2", an = {
  font: sn
}, cn = {
  $style: an
}, l1 = /* @__PURE__ */ B(ln, [["__cssModules", cn], ["__scopeId", "data-v-846d835e"]]);
var Le = /* @__PURE__ */ ((e) => (e.Md = "md", e.Sm = "sm", e))(Le || {});
const rn = /* @__PURE__ */ _({
  __name: "BgBadge",
  props: {
    color: { default: Z.GreySemiLight },
    size: { default: Le.Md },
    fullWidth: { type: Boolean }
  },
  setup(e) {
    oe((l) => ({
      "216a6bf2": n.value.padding,
      "18d325a2": n.value.fontSize,
      "1177d48c": o.value.backgroundColor,
      "1dbcb888": o.value.color,
      e22edec6: n.value.borderRadius,
      "35b86126": n.value.height
    }));
    const t = e, o = w(() => ({
      backgroundColor: V(t.color),
      color: O0(t.color)
    })), n = w(() => ({
      [Le.Sm]: {
        height: "16px",
        borderRadius: "100px",
        fontSize: Fe[0],
        padding: `0 ${j.xSm}`
      },
      [Le.Md]: {
        height: "32px",
        borderRadius: "100px",
        fontSize: Fe[1],
        padding: `0 ${j.sm}`
      }
    })[t.size]);
    return (l, s) => (v(), b(r(k), {
      is: "div",
      class: x([l.$style.badge, {
        [l.$style.full]: l.fullWidth
      }])
    }, {
      default: g(() => [
        y(l.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), un = "_badge_1ie0m_2", dn = "_full_1ie0m_17", fn = {
  badge: un,
  full: dn
}, pn = {
  $style: fn
}, mn = /* @__PURE__ */ B(rn, [["__cssModules", pn], ["__scopeId", "data-v-7783b983"]]);
var U = /* @__PURE__ */ ((e) => (e["2xSm"] = "2x-sm", e.XSm = "x-sm", e.Sm = "sm", e.Md = "md", e.Lg = "lg", e.XLg = "x-lg", e["2xLg"] = "2x-lg", e))(U || {});
const hn = /* @__PURE__ */ _({
  __name: "BgStack",
  props: {
    space: {},
    is: { default: "div" }
  },
  setup(e) {
    oe((n) => ({
      "06ffa1c0": o.value
    }));
    const t = e;
    le(t, ["space"]);
    const o = w(() => ({
      [U["2xSm"]]: j["2xSm"],
      [U.XSm]: j.xSm,
      [U.Sm]: j.sm,
      [U.Md]: j.md,
      [U.Lg]: j.lg,
      [U.XLg]: j.xLg,
      [U["2xLg"]]: j["2xLg"]
    })[t.space]);
    return (n, l) => (v(), b(k, {
      is: n.is,
      class: x(n.$style.container)
    }, {
      default: g(() => [
        y(n.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["is", "class"]));
  }
}), gn = "_container_ri13c_2", vn = {
  container: gn
}, bn = {
  $style: vn
}, al = /* @__PURE__ */ B(hn, [["__cssModules", bn], ["__scopeId", "data-v-cd44c365"]]);
const yn = {}, _n = { class: "bg-card" };
function wn(e, t) {
  return v(), P("div", _n, [
    y(e.$slots, "default", {}, void 0, !0)
  ]);
}
const il = /* @__PURE__ */ B(yn, [["render", wn], ["__scopeId", "data-v-e567d788"]]);
var Ae = /* @__PURE__ */ ((e) => (e.Sm = "sm", e.Md = "md", e))(Ae || {}), he = /* @__PURE__ */ ((e) => (e.Solid = "solid", e.Outline = "outline", e.Ghost = "ghost", e))(he || {});
const xn = /* @__PURE__ */ _({
  __name: "BgButton",
  props: {
    size: { default: Ae.Md },
    variant: { default: he.Solid },
    leftIcon: { default: null },
    rightIcon: { default: null },
    fullWidth: { type: Boolean }
  },
  setup(e) {
    oe((s) => ({
      "7e622942": o.value.height,
      "73a66b1c": n.value.border,
      "240cb154": o.value.padding,
      "602d4f4f": n.value.backgroundColor,
      "87c00f46": n.value.color,
      53716932: l.value,
      d222c266: n.value.hoverColor
    }));
    const t = e, o = w(() => ({
      [Ae.Sm]: {
        height: kt.sm,
        padding: `0 ${Bt.lg}`
      },
      [Ae.Md]: {
        height: kt.md,
        padding: `0 ${Bt.xLg}`
      }
    })[t.size]), n = w(() => ({
      [he.Solid]: {
        backgroundColor: V(Z.BlueNormal),
        color: V(Z.GreyWhite),
        hoverColor: V(Z.BlueSemiDark),
        iconColor: Z.GreyWhite,
        border: "none"
      },
      [he.Outline]: {
        backgroundColor: "transparent",
        color: V(Z.BlueSemiDark),
        hoverColor: "#E2F4FD",
        iconColor: Z.BlueSemiDark,
        border: `1px solid ${V(Z.BlueSemiDark)}`
      },
      [he.Ghost]: {
        backgroundColor: "transparent",
        color: V(Z.BlueSemiDark),
        hoverColor: V(Z.BgBackgroundAlt),
        iconColor: Z.BlueSemiDark,
        border: "none"
      }
    })[t.variant]), l = w(() => t.fullWidth ? "100%" : "auto");
    return (s, a) => (v(), b(r(k), {
      is: "button",
      class: x(s.$style[t.variant])
    }, {
      default: g(() => [
        t.leftIcon ? (v(), b(r(_e), {
          key: 0,
          name: t.leftIcon,
          color: n.value.iconColor,
          class: x(s.$style.leftIcon)
        }, null, 8, ["name", "color", "class"])) : J("", !0),
        y(s.$slots, "default", {}, void 0, !0),
        t.rightIcon ? (v(), b(r(_e), {
          key: 1,
          name: t.rightIcon,
          color: n.value.iconColor,
          class: x(s.$style.rightIcon)
        }, null, 8, ["name", "color", "class"])) : J("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Mn = "_left-icon_shkj1_35", $n = "_right-icon_shkj1_40", kn = {
  leftIcon: Mn,
  rightIcon: $n
}, Bn = {
  $style: kn
}, De = /* @__PURE__ */ B(xn, [["__cssModules", Bn], ["__scopeId", "data-v-893f680c"]]), s1 = Symbol("BgFiltersRegister"), a1 = Symbol("BgFiltersList"), Ln = Symbol("BgFiltersContext"), i1 = () => Ln, An = Symbol("BgFilterContext"), c1 = () => An, Zn = ["aria-label", "aria-activedescendant"], Sn = /* @__PURE__ */ _({
  __name: "BgFilters",
  props: /* @__PURE__ */ rt({
    label: { default: "Filtros" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ rt(["apply", "cancel"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const o = t, n = x1(e, "modelValue"), l = S({}), s = S();
    te(i1(), {
      filters: l
    });
    const a = () => {
      l.value = structuredClone(ut(n.value || {}));
    }, i = () => {
      var d;
      n.value = structuredClone(ut(l.value)), (d = s.value) == null || d.close();
    }, c = () => {
      var d;
      (d = s.value) == null || d.close(), a(), o("cancel");
    }, u = () => {
      var d, M;
      (M = (d = f.value) == null ? void 0 : d.ref) == null || M.toggle();
    }, { items: p } = lt({
      injectionKey: s1
    }), { next: h, prev: m, activeItem: f } = nt({
      injectionKey: a1,
      items: p
    });
    return D(() => n, a, {
      immediate: !0,
      deep: !0
    }), (d, M) => (v(), b(r(o1), {
      ref_key: "popover",
      ref: s,
      "focus-trigger-on-close": "",
      "aria-label": d.label,
      role: "dialog",
      onClose: c
    }, {
      button: g((L) => [
        $(r(De), re(L, {
          variant: "outline",
          "left-icon": "filter",
          size: "sm"
        }), {
          default: g(() => [
            O(G(d.label), 1)
          ]),
          _: 2
        }, 1040)
      ]),
      default: g(() => [
        T("div", {
          class: x(d.$style.container)
        }, [
          T("div", {
            class: x(d.$style.list),
            role: "listbox",
            tabindex: "0",
            "aria-multiselectable": "true",
            "aria-label": d.label,
            "aria-activedescendant": r(f) && r(f).id,
            onKeydown: [
              M[0] || (M[0] = ge(
                //@ts-ignore
                (...L) => r(h) && r(h)(...L),
                ["down"]
              )),
              M[1] || (M[1] = ge(
                //@ts-ignore
                (...L) => r(m) && r(m)(...L),
                ["up"]
              )),
              ge(u, ["space"])
            ]
          }, [
            y(d.$slots, "default")
          ], 42, Zn),
          T("div", {
            class: x(d.$style.footer),
            role: "toolbar"
          }, [
            $(r(De), {
              size: "sm",
              variant: "outline",
              "full-width": "",
              onClick: c
            }, {
              default: g(() => [
                O(" Cancelar ")
              ]),
              _: 1
            }),
            $(r(De), {
              size: "sm",
              "full-width": "",
              onClick: i
            }, {
              default: g(() => [
                O(" Aplicar ")
              ]),
              _: 1
            })
          ], 2)
        ], 2)
      ]),
      _: 3
    }, 8, ["aria-label"]));
  }
}), Cn = "_container_5ulsx_2", Hn = "_list_5ulsx_9", In = "_footer_5ulsx_14", Nn = {
  container: Cn,
  list: Hn,
  footer: In
}, Vn = {
  $style: Nn
}, qe = /* @__PURE__ */ B(Sn, [["__cssModules", Vn]]), Pn = /* @__PURE__ */ _({
  __name: "BgFilter",
  props: {
    label: {}
  },
  setup(e) {
    const t = we(), o = ie(), { filters: n } = ue({
      parentName: qe.name,
      injectionKey: i1()
    });
    return n.value[t] || (n.value[t] = {}), te(c1(), {
      filterKey: t,
      filters: n
    }), (l, s) => (v(), b(r(k), {
      is: "ul",
      role: "group",
      "aria-labelledby": r(o),
      class: x(l.$style.group)
    }, {
      default: g(() => [
        $(r(k), {
          is: "li",
          id: r(o),
          class: x(l.$style.label),
          role: "presentation"
        }, {
          default: g(() => [
            $(r(l1), {
              type: "small",
              color: "grey-semi-light"
            }, {
              default: g(() => [
                O(G(l.label), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["id", "class"]),
        y(l.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["aria-labelledby", "class"]));
  }
}), En = "_label_ipiy3_2", Rn = "_group_ipiy3_7", Dn = {
  label: En,
  group: Rn
}, Tn = {
  $style: Dn
}, On = /* @__PURE__ */ B(Pn, [["__cssModules", Tn], ["__scopeId", "data-v-f210caba"]]), zn = ["id", "aria-checked", "aria-labelledby"], Fn = ["id"], jn = /* @__PURE__ */ _({
  __name: "BgFilterOption",
  props: {
    label: {}
  },
  setup(e, { expose: t }) {
    const o = we(), n = ie(), { isActive: l } = Ve({
      injectionKey: a1,
      parentName: qe.name
    }), { filterKey: s, filters: a } = ue({
      parentName: On.name,
      injectionKey: c1()
    }), { id: i } = st({
      parentName: qe.name,
      injectionKey: s1
    }), c = w({
      get: () => a.value[s][o],
      set: (p) => {
        a.value[s][o] = p;
      }
    }), u = () => {
      c.value = !c.value;
    };
    return c.value === void 0 && (c.value = !1), t({ toggle: u }), (p, h) => (v(), b(r(k), {
      is: "li",
      role: "option",
      class: x({
        [p.$style.focus]: r(l)
      }),
      onClick: u
    }, {
      default: g(() => [
        T("div", {
          class: x([p.$style.content])
        }, [
          T("div", {
            id: r(i),
            "aria-checked": c.value,
            role: "checkbox",
            "aria-labelledby": r(n)
          }, null, 8, zn),
          T("label", { id: r(n) }, G(p.label), 9, Fn)
        ], 2)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Gn = "_content_1vy1d_7", Kn = "_focus_1vy1d_49", Wn = {
  content: Gn,
  focus: Kn
}, qn = {
  $style: Wn
}, cl = /* @__PURE__ */ B(jn, [["__cssModules", qn], ["__scopeId", "data-v-0caca3a6"]]), Xn = (e) => ({
  ...r1(),
  ...e
}), Yn = (e = []) => {
  const t = new URLSearchParams(window.location.search);
  for (const o of e)
    t.delete(o);
  return r1(t);
}, r1 = (e = new URLSearchParams(window.location.search)) => {
  const t = {};
  for (const [o, n] of e.entries())
    t[o] = n;
  return t;
}, Un = Symbol("DialogStack"), rl = (e, { router: t }) => {
  const o = (l) => l ? Xn({ dialog: `${l}` }) : Yn(["dialog"]), n = {
    stack: [],
    get size() {
      return this.stack.length;
    },
    open(l) {
      return this.stack.push({ ref: l }), t.push({ query: o(this.size) });
    },
    async close(l) {
      const s = this.stack.findIndex((a) => a.ref === l);
      if (s !== -1)
        return this.stack.splice(s, 1), this.size === 0 ? t.replace({ query: o(0) }) : t.go(-1);
    },
    async pop() {
      var s, a;
      if (this.size === 0)
        return;
      const l = this.stack.pop();
      await ((a = (s = l == null ? void 0 : l.ref) == null ? void 0 : s.close) == null ? void 0 : a.call(s));
    }
  };
  t.beforeEach(async (l, s, a) => {
    var h, m;
    const i = Number(((h = s == null ? void 0 : s.query) == null ? void 0 : h.dialog) || 0), c = Number(((m = l == null ? void 0 : l.query) == null ? void 0 : m.dialog) || 0), u = i < c, p = i > c;
    return !n.size && c ? a({ ...l, query: o(0) }) : (p && n.size > c && await n.pop(), u ? n.size < c ? a(!1) : a(!!n.size) : a());
  }), e.provide(Un, {
    open: n.open.bind(n),
    close: n.close.bind(n)
  });
};
export {
  mn as BgBadge,
  De as BgButton,
  il as BgCard,
  On as BgFilter,
  cl as BgFilterOption,
  qe as BgFilters,
  _e as BgIcon,
  sl as BgIllustration,
  it as BgLink,
  Lo as BgMenu,
  We as BgMenuItem,
  Wo as BgMenuItemFooter,
  At as BgMenuItemGroup,
  $t as BgSidebar,
  ro as BgSidebarGroup,
  nl as BgSidebarItem,
  al as BgStack,
  tl as BgTab,
  ol as BgTabPanel,
  el as BgTabs,
  l1 as BgText,
  ll as BgTopbar,
  tn as BgTopbarItem,
  rl as DialogStack,
  Un as DialogStackIK
};
//# sourceMappingURL=bridge.js.map
